function focusVisiblePolyfill() {
  let e = ["Tab", "ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight", "Enter", "Space", "Escape",
      "Home", "End", "PageUp", "PageDown"
    ],
    t = null,
    i = null;
  window.addEventListener("keydown", t => {
    e.includes(t.code) && (i = !1)
  }), window.addEventListener("mousedown", () => {
    i = !0
  }), window.addEventListener("focus", () => {
    t && t.classList.remove("is-focused"), i || (t = document.activeElement).classList.add(
      "is-focused")
  }, !0)
}
try {
  document.querySelector(":focus-visible")
} catch (e) {
  focusVisiblePolyfill()
}

function debounce(e, t = 300) {
  let i;
  return (...s) => {
    clearTimeout(i), i = setTimeout(() => e.apply(this, s), t)
  }
}

function setViewportHeight() {
  document.documentElement.style.setProperty("--viewport-height", `${window.innerHeight}px`)
}

function setHeaderHeight() {
  let e = document.getElementById("shopify-section-header");
  if (!e) return;
  let t = e.offsetHeight,
    i = document.getElementById("shopify-section-announcement");
  i && (t += i.offsetHeight), document.documentElement.style.setProperty("--header-height",
    `${t}px`)
}

function setScrollbarWidth() {
  document.documentElement.style.setProperty("--scrollbar-width",
    `${window.innerWidth-document.documentElement.clientWidth}px`)
}

function setDimensionVariables() {
  setViewportHeight(), setHeaderHeight(), setScrollbarWidth()
}

function setImageSources(e) {
  let t = e => {
    e.dataset.src && !e.src && (e.src = e.dataset.src), e.dataset.srcset && !e.srcset && (e
      .srcset = e.dataset.srcset)
  };
  "PICTURE" === e.parentNode.tagName ? Array.from(e.parentNode.children).forEach(e => {
    t(e)
  }) : t(e)
}

function initLazyImages() {
  if ("loading" in HTMLImageElement.prototype == !1 && "IntersectionObserver" in window) {
    let e = new IntersectionObserver((e, t) => {
      e.forEach(e => {
        if (e.isIntersecting) {
          let i = e.target;
          setImageSources(i), t.unobserve(i)
        }
      })
    }, {
      rootMargin: "0px 0px 500px 0px"
    });
    document.querySelectorAll('[loading="lazy"]').forEach(t => {
      e.observe(t)
    })
  } else document.querySelectorAll('[loading="lazy"]').forEach(e => {
    setImageSources(e)
  })
}

function initLazyScript(e, t, i = 500) {
  if ("IntersectionObserver" in window) {
    let s = new IntersectionObserver((e, i) => {
      e.forEach(e => {
        e.isIntersecting && "function" == typeof t && (t(), i.unobserve(e.target))
      })
    }, {
      rootMargin: `0px 0px ${i}px 0px`
    });
    s.observe(e)
  } else t()
}

function pauseAllMedia(e = document) {
  e.querySelectorAll(".js-youtube, .js-vimeo, video").forEach(e => {
    let t = e.closest("video-component");
    t && "true" === t.dataset.background || (e.matches(".js-youtube") ? e.contentWindow
      .postMessage('{ "event": "command", "func": "pauseVideo", "args": "" }', "*") : e
      .matches(".js-vimeo") ? e.contentWindow.postMessage('{ "method": "pause" }', "*") : e
      .pause())
  }), e.querySelectorAll("product-model").forEach(e => {
    e.modelViewerUI && e.modelViewerUI.pause()
  })
}(() => {
  let {
    mediaQueries: e
  } = theme;
  if (!e) return;
  let t = Object.keys(e),
    i = {};
  theme.mediaMatches = {};
  let s = () => {
    let e = t.reduce((e, t) => (e[t] = !!(i[t] && i[t].matches), e), {});
    Object.keys(e).forEach(t => {
      theme.mediaMatches[t] = e[t]
    }), window.dispatchEvent(new CustomEvent("on:breakpoint-change"))
  };
  t.forEach(t => {
    i[t] = window.matchMedia(e[t]), theme.mediaMatches[t] = i[t].matches;
    try {
      i[t].addEventListener("change", s)
    } catch (n) {
      i[t].addListener(s)
    }
  })
})(), document.addEventListener("DOMContentLoaded", setDimensionVariables), window.addEventListener(
  "resize", debounce(setDimensionVariables, 400)), setTimeout(setViewportHeight, 3e3);
class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    let e = this.querySelector(".js-load-media");
    e ? e.addEventListener("click", this.loadContent.bind(this)) : this.addObserver()
  }
  addObserver() {
    if ("IntersectionObserver" in window == !1) return;
    let e = new IntersectionObserver(t => {
      t.forEach(t => {
        t.isIntersecting && (this.loadContent(!1, !1, "observer"), e.unobserve(this))
      })
    }, {
      rootMargin: "0px 0px 1000px 0px"
    });
    e.observe(this)
  }
  loadContent(e = !0, t = !0, i = "click") {
    if (t && pauseAllMedia(), null !== this.getAttribute("loaded")) return;
    this.loadTrigger = i;
    let s = this.querySelector("template").content.firstElementChild.cloneNode(!0);
    this.appendChild(s), this.setAttribute("loaded", "");
    let n = this.querySelector("video, model-viewer, iframe");
    n && e && n.focus()
  }
}
customElements.define("deferred-media", DeferredMedia);
class DetailsDisclosure extends HTMLElement {
  constructor() {
    super(), this.disclosure = this.querySelector("details"), this.toggle = this.querySelector(
      "summary"), this.panel = this.toggle.nextElementSibling, this.init()
  }
  init() {
    "0s" !== window.getComputedStyle(this.panel).transitionDuration && (this.toggle
      .addEventListener("click", this.handleToggle.bind(this)), this.disclosure
      .addEventListener("transitionend", this.handleTransitionEnd.bind(this)))
  }
  handleToggle(e) {
    e.preventDefault(), this.disclosure.open ? this.close() : this.open()
  }
  handleTransitionEnd(e) {
    e.target === this.panel && (this.disclosure.classList.contains("is-closing") && (this
        .disclosure.classList.remove("is-closing"), this.disclosure.open = !1), this.panel
      .removeAttribute("style"))
  }
  addContentHeight() {
    this.panel.style.height = `${this.panel.scrollHeight}px`
  }
  open() {
    this.panel.style.height = "0", this.disclosure.open = !0, this.addContentHeight()
  }
  close() {
    this.addContentHeight(), this.disclosure.classList.add("is-closing"), setTimeout(() => {
      this.panel.style.height = "0"
    })
  }
}
customElements.define("details-disclosure", DetailsDisclosure);
const trapFocusHandlers = {};

function removeTrapFocus(e = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin), document.removeEventListener(
    "focusout", trapFocusHandlers.focusout), document.removeEventListener("keydown",
    trapFocusHandlers.keydown), e && e.focus()
}

function trapFocus(e, t = e) {
  let i = Array.from(e.querySelectorAll(
      'summary, a[href], area[href], button:not([disabled]), input:not([type=hidden]):not([disabled]), select:not([disabled]), textarea:not([disabled]), object, iframe, audio[controls], video[controls], [tabindex]:not([tabindex^="-"])'
      )),
    s = i[0],
    n = i[i.length - 1];
  removeTrapFocus(), trapFocusHandlers.focusin = t => {
    (t.target === e || t.target === n || t.target === s) && document.addEventListener("keydown",
      trapFocusHandlers.keydown)
  }, trapFocusHandlers.focusout = () => {
    document.removeEventListener("keydown", trapFocusHandlers.keydown)
  }, trapFocusHandlers.keydown = t => {
    "Tab" === t.code && (t.target !== n || t.shiftKey || (t.preventDefault(), s.focus()), (t
      .target === e || t.target === s) && t.shiftKey && (t.preventDefault(), n.focus()))
  }, document.addEventListener("focusout", trapFocusHandlers.focusout), document.addEventListener(
    "focusin", trapFocusHandlers.focusin), (t || e).focus()
}
class Modal extends HTMLElement {
  constructor() {
    super(), this.addEventListener("click", this.handleClick.bind(this))
  }
  handleClick(e) {
    (e.target === this || e.target.matches(".js-close-modal")) && this.close()
  }
  open(e) {
    this.scrollY = window.scrollY, document.body.classList.add("fixed"), document.body.style.top =
      `-${this.scrollY}px`, this.setAttribute("open", ""), this.openedBy = e, trapFocus(this),
      window.pauseAllMedia(), this.keyupHandler = e => "Escape" === e.key && this.close(), this
      .addEventListener("keyup", this.keyupHandler), this.querySelectorAll("table").forEach(e => {
        let t = document.createElement("div");
        t.className = "scrollable-table", e.parentNode.insertBefore(t, e), t.appendChild(e)
      })
  }
  close() {
    document.body.style.top = "", document.body.classList.remove("fixed"), window.scrollTo(0, this
        .scrollY), this.removeAttribute("open"), removeTrapFocus(this.openedBy), window
      .pauseAllMedia(), this.removeEventListener("keyup", this.keyupHandler)
  }
}
customElements.define("modal-dialog", Modal);
class ModalOpener extends HTMLElement {
  constructor() {
    super();
    let e = this.querySelector("button");
    if (!e) return;
    e.addEventListener("click", () => {
      let t = document.getElementById(this.dataset.modal);
      t && t.open(e)
    })
  }
}
customElements.define("modal-opener", ModalOpener);
class ProductCard extends HTMLElement {
  constructor() {
    super(), window.initLazyScript(this, this.init.bind(this))
  }
  init() {
    this.images = this.querySelectorAll(".card__main-image"), this.links = this.querySelectorAll(
        ".js-prod-link"), this.quickAddBtn = this.querySelector(".js-quick-add"), this
      .quickAddBtn ? this.productUrl = this.quickAddBtn.dataset.productUrl : this.links.length &&
      (this.productUrl = this.links[0].href), this.addEventListener("change", this
        .handleSwatchChange.bind(this))
  }
  handleSwatchChange(e) {
    if (!e.target.matches(".opt-btn")) return;
    if (e.target.dataset.mediaId) {
      let t = this.querySelector(`[data-media-id="${e.target.dataset.mediaId}"]`);
      t && (this.images.forEach(e => {
        e.hidden = !0
      }), t.hidden = !1)
    }
    let i = this.productUrl.split("?").length > 1 ? "&" : "?",
      s = `${this.productUrl+i}variant=${e.target.dataset.variantId}`;
    this.links.forEach(e => {
      e.href = s
    }), this.quickAddBtn && (this.quickAddBtn.dataset.selectedColor = e.target.value)
  }
}
customElements.define("product-card", ProductCard);
class QuantityInput extends HTMLElement {
  constructor() {
    super(), this.input = this.querySelector(".qty-input__input"), this.currentQty = this.input
      .value, this.changeEvent = new Event("change", {
        bubbles: !0
      }), this.addEventListener("click", this.handleClick.bind(this)), this.input
      .addEventListener("focus", QuantityInput.handleFocus), this.input.addEventListener(
        "keydown", this.handleKeydown.bind(this))
  }
  handleClick(e) {
    e.target.matches(".qty-input__btn") && (e.preventDefault(), this.currentQty = this.input
      .value, "plus" === e.target.name ? this.input.stepUp() : this.input.stepDown(), this.input
      .value !== this.currentQty && (this.input.dispatchEvent(this.changeEvent), this
        .currentQty = this.input.value))
  }
  static handleFocus(e) {
    window.matchMedia("(pointer: fine)").matches && e.target.select()
  }
  handleKeydown(e) {
    "Enter" === e.key && (e.preventDefault(), this.input.value !== this.currentQty && (this.input
      .blur(), this.input.focus(), this.currentQty = this.input.value))
  }
}
customElements.define("quantity-input", QuantityInput);
class SideDrawer extends HTMLElement {
  constructor() {
    super(), this.overlay = document.querySelector(".js-overlay")
  }
  handleClick(e) {
    (e.target.matches(".js-close-drawer") || e.target === this.overlay) && this.close()
  }
  open(e, t, i) {
    this.dispatchEvent(new CustomEvent(`on:${this.dataset.name}:before-open`, {
        bubbles: !0
      })), this.scrollY = window.scrollY, document.body.classList.add("fixed"), document.body
      .style.top = `-${this.scrollY}px`, document.documentElement.style.height = "100vh", this
      .overlay.classList.add("is-visible"), this.setAttribute("open", ""), this.setAttribute(
        "aria-hidden", "false"), this.opener = e, trapFocus(this, t), this.clickHandler = this
      .clickHandler || this.handleClick.bind(this), this.keyupHandler = e => {
        "Escape" !== e.key || e.target.closest(".cart-drawer-popup") || this.close()
      }, this.addEventListener("click", this.clickHandler), this.addEventListener("keyup", this
        .keyupHandler), this.overlay.addEventListener("click", this.clickHandler);
    let s = parseFloat(getComputedStyle(this).getPropertyValue("--longest-transition-in-ms"));
    setTimeout(() => {
      i && i(), this.dispatchEvent(new CustomEvent(`on:${this.dataset.name}:after-open`, {
        bubbles: !0
      }))
    }, s)
  }
  close(e) {
    this.dispatchEvent(new CustomEvent(`on:${this.dataset.name}:before-close`, {
        bubbles: !0
      })), this.removeAttribute("open"), this.setAttribute("aria-hidden", "true"), this.overlay
      .classList.remove("is-visible"), removeTrapFocus(this.opener), document.documentElement
      .style.height = "", document.body.style.top = "", document.body.classList.remove("fixed"),
      window.scrollTo(0, this.scrollY), this.removeEventListener("click", this.clickHandler), this
      .removeEventListener("keyup", this.keyupHandler), this.overlay.removeEventListener("click",
        this.clickHandler);
    let t = parseFloat(getComputedStyle(this).getPropertyValue("--longest-transition-in-ms"));
    setTimeout(() => {
      e && e(), this.dispatchEvent(new CustomEvent(`on:${this.dataset.name}:after-close`, {
        bubbles: !0
      }))
    }, t)
  }
}

function initCssVarHeightWatch() {
  let e = document.querySelectorAll("[data-css-var-height]");
  if (e) {
    let t = e => {
        let t = e.closest("[data-css-var-height]");
        if (t) {
          let i = t.dataset.cssVarHeight.split(","),
            s = null;
          i.forEach(t => {
            e.matches(t.trim()) && (s = t.trim())
          });
          let n = `--${s.replace(/^([#.])/,"")}-height`;
          t.style.setProperty(n, `${e.getBoundingClientRect().height.toFixed(2)}px`)
        }
      },
      i = null;
    "MutationObserver" in window && (i = new MutationObserver(debounce(e => {
      let i = e[0].target.closest("[data-css-var-height]");
      i && t(i.querySelector(i.dataset.cssVarHeight))
    }))), e.forEach(e => {
      e.dataset.cssVarHeight.split(",").forEach(s => {
        let n = e.querySelector(s);
        n && (i && i.observe(n, {
          childList: !0,
          attributes: !0,
          subtree: !0
        }), window.addEventListener("on:debounced-resize", () => {
          let i = e.querySelector(s);
          i && t(i)
        }), document.addEventListener("on:css-var-height:update", () => {
          let i = e.querySelector(s);
          i && t(i)
        }), t(n))
      })
    })
  }
}
customElements.define("side-drawer", SideDrawer), window.addEventListener("resize", debounce(() => {
    window.dispatchEvent(new CustomEvent("on:debounced-resize"))
  })), document.addEventListener("DOMContentLoaded", initCssVarHeightWatch), document
  .addEventListener("shopify:section:load", initCssVarHeightWatch), theme.elementUtil = {}, theme
  .elementUtil.remove = e => {
    e && ("function" == typeof e.remove ? e.remove() : e.forEach(e => {
      e.remove()
    }))
  }, theme.elementUtil.isInViewport = e => {
    let t = e.getBoundingClientRect();
    return Math.round(t.top) >= 0 && Math.round(t.left) >= 0 && Math.round(t.bottom) <= (window
      .innerHeight || document.documentElement.clientHeight) && Math.round(t.right) <= (window
      .innerWidth || document.documentElement.clientWidth)
  }, theme.storageUtil = {}, theme.storageUtil.set = (e, t, i) => {
    i ? sessionStorage.setItem(`cc-${e}`, "object" == typeof t ? JSON.stringify(t) : t) :
      localStorage.setItem(`cc-${e}`, "object" == typeof t ? JSON.stringify(t) : t)
  }, theme.storageUtil.get = (e, t, i) => {
    let s = i ? sessionStorage.getItem(`cc-${e}`) : localStorage.getItem(`cc-${e}`);
    return t && (s = JSON.parse(s)), s
  }, theme.storageUtil.remove = (e, t) => {
    t ? sessionStorage.removeItem(`cc-${e}`) : localStorage.removeItem(`cc-${e}`)
  };
class StoreHeader extends HTMLElement {
  constructor() {
    super(), this.menu = this.querySelector(".main-menu__content"), this.searchToggle = this
      .querySelector(".js-show-search"), this.searchToggleLeft = this.querySelector(
        ".js-show-search-left"), this.mobNavToggle = this.querySelector(".main-menu__toggle"),
      this.shakeyCartIcon = this.querySelector(".header__icon--cart-shake"), this
      .headerGroupSections = document.querySelectorAll(".shopify-section-group-header-group"),
      this.stickyInitialised = !1, this.stickyTransitioning = !1, this.lastScrollPos = 0, this
      .headerTransitionSpeed = parseFloat(getComputedStyle(this).getPropertyValue(
        "--header-transition-speed")), window.setHeaderHeight(), this.bindEvents(), this.init(),
      document.addEventListener("DOMContentLoaded", this.setMenuHeight.bind(this))
  }
  disconnectedCallback() {
    window.removeEventListener("on:debounced-resize", this.resizeHandler), this
      .breakpointChangeHandler && window.removeEventListener("on:breakpoint-change", this
        .breakpointChangeHandler)
  }
  bindEvents() {
    this.resizeHandler = this.resizeHandler || this.updateHeaderHeights.bind(this), window
      .addEventListener("on:debounced-resize", this.resizeHandler), this.mobNavToggle
      .addEventListener("click", window.setHeaderHeight), this.mobNavToggle.addEventListener(
        "click", this.setHeaderEnd.bind(this)), this.dataset.isSticky && (this
        .breakpointChangeHandler = this.breakpointChangeHandler || this.init.bind(this), window
        .addEventListener("on:breakpoint-change", this.breakpointChangeHandler)), this.dataset
      .isSearchMinimised && (this.searchToggle && this.searchToggle.addEventListener("click", this
          .handleSearchToggleClick.bind(this)), this.searchToggleLeft && this.searchToggleLeft
        .addEventListener("click", this.handleSearchToggleClick.bind(this)))
  }
  init() {
    if (this.updateHeaderHeights(), this.dataset.isSticky && (theme.mediaMatches.md && !this
        .stickyInitialised && (this.stickyInitialised = !0, window.addEventListener("scroll", this
          .handleScroll.bind(this))), this.setMenuHeight(), this.setHeaderEnd()), this.shakeyCartIcon) {
      let e = theme.storageUtil.get("shake-page-count", !1, !0);
      e = e ? parseInt(e, 10) + 1 : 1;
      let t = parseInt(this.shakeyCartIcon.dataset.shakeFrequency, 10);
      e < t ? this.shakeyCartIcon.classList.remove("header__icon--cart-shake") : e = 0, theme
        .storageUtil.set("shake-page-count", e, !0)
    }
  }
  handleSearchToggleClick(e) {
    e.preventDefault();
    let t = this.querySelector(".js-search-bar");
    this.classList.contains("search-is-collapsed") ? (this.classList.remove(
      "search-is-collapsed"), setTimeout(() => {
        this.classList.add("search-is-visible");
        let e = t.querySelector(".js-search-input");
        e.focus(), window.setHeaderHeight()
      }, this.headerTransitionSpeed)) : (this.classList.remove("search-is-visible"), setTimeout(
      () => {
        this.classList.add("search-is-collapsed")
      }), setTimeout(window.setHeaderHeight, this.headerTransitionSpeed))
  }
  updateHeaderHeights() {
    if (theme.mediaMatches.md ? (this.setMenuHeight(), setTimeout(window.setHeaderHeight, this
        .headerTransitionSpeed)) : window.setHeaderHeight(), this.headerGroupSections && this
      .headerGroupSections.length > 0) {
      let e = 0;
      this.headerGroupSections.forEach(t => {
        e += t.getBoundingClientRect().height
      }), e > 0 && document.documentElement.style.setProperty("--content-start",
        `${e.toFixed(1)}px`)
    }
  }
  setMenuHeight() {
    this.menu && this.menu.clientHeight && (this.style.setProperty("--menu-height",
      `${this.menu.clientHeight+16}px`), document.documentElement.style.setProperty(
      "--header-height", `${this.clientHeight}px`))
  }
  handleScroll() {
    document.body.classList.contains("fixed") || this.stickyTransitioning || (document
      .documentElement.scrollTop < 200 ? this.show() : this.lastScrollPos < document
      .documentElement.scrollTop ? this.hide() : this.lastScrollPos - 5 > document
      .documentElement.scrollTop && this.show(), this.lastScrollPos = document.documentElement
      .scrollTop)
  }
  setHeaderEnd() {
    let e = Number(this.getBoundingClientRect().top + this.clientHeight);
    document.documentElement.style.setProperty("--header-end", `${e.toFixed(1)}px`), document
      .documentElement.style.setProperty("--header-end-padded",
        `${(e+(theme.mediaMatches.md?56:20)).toFixed(1)}px`)
  }
  show() {
    this.classList.remove("is-out"), this.stickyTransitioning = !0, setTimeout(() => {
      this.lastScrollPos = document.documentElement.scrollTop, this.stickyTransitioning = !1,
        this.handleScroll(), this.setHeaderEnd()
    }, 300)
  }
  hide() {
    this.stickyTransitioning || (this.classList.add("is-out"), this.stickyTransitioning = !0,
      setTimeout(() => {
        this.lastScrollPos = document.documentElement.scrollTop, this.stickyTransitioning = !
          1, this.handleScroll(), this.setHeaderEnd()
      }, 300))
  }
}
customElements.define("store-header", StoreHeader);
class MainMenu extends HTMLElement {
  constructor() {
    super(), this.mainDisclosure = this.querySelector(".main-menu__disclosure"), this.mainToggle =
      this.querySelector(".main-menu__toggle"), this.firstLevelMenuLinks = this.querySelectorAll(
        ".js-nav-hover"), this.firstLevelSingleLinks = this.querySelectorAll(
        ".main-nav__item--primary:not(.main-nav__item-content)"), this.nav = this.querySelector(
        ".main-nav"), this.overlay = document.querySelector(".js-overlay"), this.searchIcon =
      document.querySelector(".header__icons .js-show-search"), this.sidebarLinks = this
      .querySelectorAll(".js-sidebar-hover"), this.elementsWhichCloseMenus = document
      .querySelectorAll(".js-closes-menu"), this.isTouchEvent = !1, this.childNavOpen = !1, this
      .overlayOpen = !1, this.addListeners(), this.init()
  }
  disconnectedCallback() {
    window.removeEventListener("focusin", this.focusOutHandler), window.removeEventListener(
      "on:breakpoint-change", this.breakpointChangeHandler), Shopify.designMode && (document
      .removeEventListener("shopify:block:select", this.blockSelectHandler), document
      .removeEventListener("shopify:block:deselect", this.blockDeselectHandler))
  }
  addListeners() {
    this.focusOutHandler = this.focusOutHandler || this.handleFocusOut.bind(this), this
      .breakpointChangeHandler = this.breakpointChangeHandler || this.init.bind(this), this
      .mainDisclosure.addEventListener("transitionend", MainMenu.handleTransition.bind(this)),
      this.mainToggle.addEventListener("click", this.handleMainMenuToggle.bind(this)), this.nav
      .addEventListener("touchstart", () => {
        this.isTouchEvent = !0
      }), this.nav.addEventListener("click", MainMenu.handleNavClick.bind(this)), this.nav
      .addEventListener("touchend", () => setTimeout(() => {
        this.isTouchEvent = !1
      }, 100)), window.addEventListener("focusin", this.focusOutHandler), window.addEventListener(
        "on:breakpoint-change", this.breakpointChangeHandler), Shopify.designMode && (this
        .blockSelectHandler = this.blockSelectHandler || this.handleBlockSelect.bind(this), this
        .blockDeselectHandler = this.blockDeselectHandler || this.handleBlockDeselect.bind(this),
        document.addEventListener("shopify:block:select", this.blockSelectHandler), document
        .addEventListener("shopify:block:deselect", this.blockDeselectHandler)), !theme
      .mediaMatches.md && this.searchIcon && this.searchIcon.addEventListener("click", this
        .closeMainDisclosure.bind(this))
  }
  init(e) {
    if (e) {
      if (theme.mediaMatches.md || this.childNavOpen) {
        let t = this.nav.querySelector("details.is-open");
        t ? this.close(t) : MainMenu.open(this.mainDisclosure, !1), !this.childNavOpen && this
          .overlayOpen && this.toggleOverlay(!1)
      } else this.close(this.mainDisclosure), this.overlayOpen && this.toggleOverlay(!1)
    } else this.mainDisclosure.open = theme.mediaMatches.md;
    this.querySelectorAll(".child-nav--dropdown details[open]").forEach(e => {
      e.removeAttribute("open")
    }), theme.device.hasHover && (this.mouseEnterMenuLinkHandler = this
      .mouseEnterMenuLinkHandler || this.handleMouseEnterMenuLink.bind(this), this
      .mouseLeaveMenuLinkHandler = this.mouseLeaveMenuLinkHandler || this
      .handleMouseLeaveMenuLink.bind(this), this.mouseEnterSingleLinkHandler = this
      .mouseEnterSingleLinkHandler || this.handleMouseEnterSingleLink.bind(this), this
      .mouseLeaveSingleLinkHandler = this.mouseLeaveSingleLinkHandler || this
      .handleMouseLeaveSingleLink.bind(this), this.mouseEnterMenuCloserHandler = this
      .mouseEnterMenuCloserHandler || this.handleClose.bind(this), !this.mouseOverListening &&
      theme.mediaMatches.md ? (this.firstLevelMenuLinks.forEach(e => {
        e.addEventListener("mouseenter", this.mouseEnterMenuLinkHandler), e
          .addEventListener("mouseleave", this.mouseLeaveMenuLinkHandler)
      }), this.firstLevelSingleLinks.forEach(e => {
        e.addEventListener("mouseenter", this.mouseEnterSingleLinkHandler), e
          .addEventListener("mouseleave", this.mouseLeaveSingleLinkHandler)
      }), this.elementsWhichCloseMenus.forEach(e => {
        e.addEventListener("mouseenter", this.mouseEnterMenuCloserHandler)
      }), this.mouseOverListening = !0) : this.mouseOverListening && !theme.mediaMatches.md && (
        this.firstLevelMenuLinks.forEach(e => {
          e.removeEventListener("mouseenter", this.mouseEnterMenuLinkHandler), e
            .removeEventListener("mouseleave", this.mouseLeaveMenuLinkHandler)
        }), this.firstLevelSingleLinks.forEach(e => {
          e.removeEventListener("mouseenter", this.mouseEnterSingleLinkHandler), e
            .removeEventListener("mouseleave", this.mouseLeaveSingleLinkHandler)
        }), this.elementsWhichCloseMenus.forEach(e => {
          e.removeEventListener("mouseenter", this.mouseEnterMenuCloserHandler)
        }), this.mouseOverListening = !1), this.sidebarLinks && (!this
        .mouseOverSidebarListening && theme.mediaMatches.md ? (this.sidebarLinks.forEach(e => {
          e.addEventListener("mouseenter", MainMenu.handleSidenavMenuToggle)
        }), this.mouseOverSidebarListening = !0) : this.mouseOverSidebarListening && !theme
        .mediaMatches.md && (this.sidebarLinks.forEach(e => {
          e.removeEventListener("mouseenter", MainMenu.handleSidenavMenuToggle)
        }), this.mouseOverSidebarListening = !1)))
  }
  handleFocusOut(e) {
    !this.contains(e.target) && this.overlayOpen && this.handleClose()
  }
  static handleSidenavMenuToggle(e, t = e.target) {
    let i = t.closest(".child-nav"),
      s = i.querySelector(".is-visible");
    s && s.classList.remove("is-visible"), t.classList.add("is-visible");
    let n = t.closest("nav-menu");
    if (n) {
      let r = n.querySelector(".disclosure__panel");
      r && i.style.setProperty("--sidebar-height",
        `${Number.parseInt(r.getBoundingClientRect().height,10)}px`)
    }
  }
  handleMainMenuToggle(e) {
    e.preventDefault(), this.opener = this.mainToggle, this.mainDisclosure.open ? this.close(this
      .mainDisclosure, !0) : MainMenu.open(this.mainDisclosure)
  }
  handleMouseEnterMenuLink(e) {
    this.closeMenuTimeout && clearTimeout(this.closeMenuTimeout),
    this.menuLinkTimeout = setTimeout(this.openMenuFromMouseEnter.bind(this, e.target), Number
      .parseInt(this.dataset.menuSensitivity, 10))
  }
  handleMouseLeaveMenuLink() {
    this.menuLinkTimeout && clearTimeout(this.menuLinkTimeout)
  }
  handleMouseEnterSingleLink() {
    this.singleLinkTimeout = setTimeout(() => {
      this.handleClose()
    }, Number.parseInt(this.dataset.menuSensitivity, 10))
  }
  handleMouseLeaveSingleLink() {
    this.singleLinkTimeout && clearTimeout(this.singleLinkTimeout)
  }
  openMenuFromMouseEnter(e) {
    trapFocus(e);
    let t = e.closest("details");
    if (!t.classList.contains("is-open")) {
      let i = this.nav.querySelector("details.is-open");
      i && i !== t ? this.close(i) : this.toggleOverlay(!this.overlayOpen), MainMenu.open(t)
    }
  }
  static handleNavClick(e) {
    let t = e.target.closest(".main-menu__content"),
      i = e.target;
    if (theme.mediaMatches.md && i.matches(".js-sidebar-hover") && i.closest("summary") && (e
        .preventDefault(), MainMenu.handleSidenavMenuToggle(e)), e.target.href && e.target.href
      .endsWith("#") && e.preventDefault(), theme.mediaMatches.md && !theme.device.hasHover && !(
        i = e.target.closest(".js-toggle"))) return;
    let s = this.isTouchEvent && theme.device.hasHover && theme.mediaMatches.md;
    if (!i.matches(".js-toggle,.js-back") && !s || i.closest("summary.child-nav__item--toggle") &&
      s) return;
    let n = i.closest("details");
    if (theme.mediaMatches.md && theme.device.hasHover && !s) {
      n.classList.toggle("is-open");
      return
    }
    if (this.opener = i, i.matches(".js-toggle") || s && i.closest("summary")) {
      if (e.preventDefault(), theme.mediaMatches.md || t.classList.add(
          "main-menu__content--no-focus"), n.classList.contains("is-open")) this.close(n, !0),
        this.childNavOpen = !1, this.toggleOverlay(!1);
      else {
        this.childNavOpen = !0;
        let r = this.nav.querySelector("details.is-open");
        r && r !== n ? this.close(r) : theme.mediaMatches.md && this.toggleOverlay(!this
          .overlayOpen), MainMenu.open(n)
      }
    } else i.matches(".js-back") && (e.preventDefault(), this.close(n, !0), this.childNavOpen = !
      1, theme.mediaMatches.md || t.classList.remove("main-menu__content--no-focus"))
  }
  static handleTransition(e) {
    let t = e.target.closest("details");
    t.classList.contains("is-closing") && (t.classList.remove("is-closing"), t.open = !1,
      removeTrapFocus(), this.opener = null)
  }
  handleClose(e) {
    if (e && "keyup" === e.type && "Escape" !== e.key) return;
    if (e && "mouseenter" === e.type && theme.mediaMatches.md) {
      let i = this.nav.querySelector("details.is-open");
      if (i && i.querySelector(".mega-nav--columns")) {
        this.closeMenuTimeout && clearTimeout(this.closeMenuTimeout), this.closeMenuTimeout =
          setTimeout(() => {
            i.matches(":hover") || this.handleClose()
          }, 350);
        return
      }
    }
    let t = theme.mediaMatches.md ? this.nav.querySelector("details.is-open") : this
      .mainDisclosure;
    t && (this.close(t, !0), this.toggleOverlay(!1), this.childNavOpen = !1)
  }
  toggleOverlay(e) {
    this.overlayOpen = e, this.overlay.classList.toggle("overlay--nav", e), this.overlay.classList
      .toggle("is-visible", e), e ? (this.closeHandler = this.closeHandler || this.handleClose
        .bind(this), this.overlay.addEventListener("click", this.closeHandler), this.nav
        .addEventListener("keyup", this.closeHandler), theme.mediaMatches.md && this.overlay
        .addEventListener("mouseenter", this.closeHandler)) : (this.overlay.removeEventListener(
          "click", this.closeHandler), this.nav.removeEventListener("keyup", this.closeHandler),
        theme.mediaMatches.md && this.overlay.removeEventListener("mouseenter", this.closeHandler)
        )
  }
  closeMainDisclosure() {
    this.mainDisclosure.classList.contains("is-open") && (this.close(this.mainDisclosure, !0),
      this.toggleOverlay(!1), this.childNavOpen = !1)
  }
  static open(e, t = !0) {
    if (e.open = !0, theme.mediaMatches.md && !e.classList.contains("js-mega-nav")) {
      let i = e.querySelector(".main-nav__child");
      i?.getBoundingClientRect().right > window.innerWidth && i.classList.add(
        "main-nav__child--offset-right");
      let s = e.querySelector(".child-nav--dropdown");
      s && s.querySelectorAll(".main-nav__grandchild").forEach(e => {
        e.style.maxWidth = `${s.clientWidth}px`
      })
    } else if (theme.mediaMatches.md && e.querySelector(".mega-nav--sidebar")) {
      let n = e.querySelector(".mega-nav--sidebar details[open] summary");
      n && MainMenu.handleSidenavMenuToggle(null, n)
    }
    setTimeout(() => {
      e.classList.remove("is-closing"), e.classList.add("is-open")
    }), t && (removeTrapFocus(), trapFocus(e), (theme.mediaMatches.md || e.classList.contains(
      "main-menu__disclosure")) && document.body.classList.add("overflow-hidden"))
  }
  close(e, t = !0) {
    e.classList.remove("is-open"), t ? e.classList.add("is-closing") : (e.classList.remove(
        "is-closing"), e.open = !1, removeTrapFocus(this.opener), this.opener = null), setTimeout(
        () => {
          let t = e.querySelector(".main-nav__child--offset-right");
          t && t.classList.remove("main-nav__child--offset-right")
        }, 200), (theme.mediaMatches.md || e.classList.contains("main-menu__disclosure")) &&
      document.body.classList.remove("overflow-hidden")
  }
  handleBlockSelect(e) {
    let t = this.nav.querySelector("details.is-open");
    t && this.close(t, !1), e.target.matches(".js-mega-nav") && (MainMenu.open(e.target, !1), this
      .toggleOverlay(!0))
  }
  handleBlockDeselect(e) {
    e.target.matches(".js-mega-nav") && (this.close(e.target, !1), this.toggleOverlay(!1))
  }
}
customElements.define("main-menu", MainMenu);
class CarouselSlider extends HTMLElement {
  constructor() {
    if (super(), this.slides = this.querySelectorAll(".slider__item"), this.slides.length < 2)
      return;
    window.initLazyScript(this, this.init.bind(this))
  }
  disconnectedCallback() {
    window.removeEventListener("on:breakpoint-change", this.breakpointChangeHandler)
  }
  init() {
    this.slider = this.querySelector(".slider"), this.grid = this.querySelector(".slider__grid"),
      this.nav = this.querySelector(".slider-nav"), this.rtl = "rtl" === document.dir, this
      .breakpointChangeHandler = this.breakpointChangeHandler || this.handleBreakpointChange.bind(
        this), this.nav && (this.prevBtn = this.querySelector('button[name="prev"]'), this
        .nextBtn = this.querySelector('button[name="next"]')), this.initSlider(), window
      .addEventListener("on:breakpoint-change", this.breakpointChangeHandler)
  }
  initSlider() {
    if (this.getAttribute("disable-mobile") && !window.matchMedia(theme.mediaQueries.sm)
      .matches || this.getAttribute("disable-desktop") && window.matchMedia(theme.mediaQueries.sm)
      .matches) this.setAttribute("inactive", "");
    else {
      if (this.gridWidth = this.grid.clientWidth, this.slideSpan = this.getWindowOffset(this
          .slides[1]) - this.getWindowOffset(this.slides[0]), this.slideGap = this.slideSpan -
        this.slides[0].clientWidth, this.slidesPerPage = Math.round((this.gridWidth + this
          .slideGap) / this.slideSpan), this.slidesToScroll = "page" === theme.settings
        .sliderItemsPerNav ? this.slidesPerPage : 1, this.totalPages = this.slides.length - this
        .slidesPerPage + 1, this.setCarouselState(this.totalPages > 1), this.totalPages < 2)
        return;
      this.sliderStart = this.getWindowOffset(this.slider), this.sliderStart || (this
          .sliderStart = (this.slider.clientWidth - this.gridWidth) / 2), this.sliderEnd = this
        .sliderStart + this.gridWidth, window.matchMedia("(pointer: fine)").matches && this.slider
        .classList.add("is-grabbable"), this.addListeners(), this.setButtonStates()
    }!this.slider.classList.contains("slider--no-scrollbar") && window.OverlayScrollbarsGlobal &&
      window.OverlayScrollbarsGlobal.OverlayScrollbars({
        target: this.slider.parentElement,
        elements: {
          viewport: this.slider
        }
      }, {})
  }
  addListeners() {
    this.nav && (this.scrollHandler = debounce(this.handleScroll.bind(this)), this
        .navClickHandler = this.handleNavClick.bind(this), this.slider.addEventListener("scroll",
          this.scrollHandler), this.nav.addEventListener("click", this.navClickHandler)), window
      .matchMedia("(pointer: fine)").matches && (this.mousedownHandler = this.handleMousedown
        .bind(this), this.mouseupHandler = this.handleMouseup.bind(this), this.mousemoveHandler =
        this.handleMousemove.bind(this), this.slider.addEventListener("mousedown", this
          .mousedownHandler), this.slider.addEventListener("mouseup", this.mouseupHandler), this
        .slider.addEventListener("mouseleave", this.mouseupHandler), this.slider.addEventListener(
          "mousemove", this.mousemoveHandler))
  }
  removeListeners() {
    this.nav && (this.slider.removeEventListener("scroll", this.scrollHandler), this.nav
        .removeEventListener("click", this.navClickHandler)), this.slider.removeEventListener(
        "mousedown", this.mousedownHandler), this.slider.removeEventListener("mouseup", this
        .mouseupHandler), this.slider.removeEventListener("mouseleave", this.mouseupHandler), this
      .slider.removeEventListener("mousemove", this.mousemoveHandler)
  }
  handleScroll() {
    this.currentIndex = Math.round(this.slider.scrollLeft / this.slideSpan), this
    .setButtonStates()
  }
  handleMousedown(e) {
    this.mousedown = !0, this.startX = e.pageX - this.sliderStart, this.scrollPos = this.slider
      .scrollLeft, this.slider.classList.add("is-grabbing")
  }
  handleMouseup() {
    this.mousedown = !1, this.slider.classList.remove("is-grabbing")
  }
  handleMousemove(e) {
    if (!this.mousedown) return;
    e.preventDefault();
    let t = e.pageX - this.sliderStart;
    this.slider.scrollLeft = this.scrollPos - (t - this.startX) * 2
  }
  handleNavClick(e) {
    e.target.matches(".slider-nav__btn") && ("next" === e.target.name && !this.rtl || "prev" === e
      .target.name && this.rtl ? this.scrollPos = this.slider.scrollLeft + this.slidesToScroll *
      this.slideSpan : this.scrollPos = this.slider.scrollLeft - this.slidesToScroll * this
      .slideSpan, this.slider.scrollTo({
        left: this.scrollPos,
        behavior: "smooth"
      }))
  }
  handleBreakpointChange() {
    this.removeListeners(), this.initSlider()
  }
  getWindowOffset(e) {
    return this.rtl ? window.innerWidth - e.getBoundingClientRect().right : e
      .getBoundingClientRect().left
  }
  getSlideVisibility(e) {
    let t = this.getWindowOffset(e),
      i = Math.floor(t + this.slides[0].clientWidth);
    return t >= this.sliderStart && i <= this.sliderEnd
  }
  setCarouselState(e) {
    e ? (this.removeAttribute("inactive"), this.gridWidth !== this.grid.clientWidth && this
      .handleBreakpointChange()) : this.setAttribute("inactive", "")
  }
  setButtonStates() {
    (this.prevBtn || this.nextBtn) && (this.prevBtn.disabled = this.getSlideVisibility(this
        .slides[0]) && 0 === this.slider.scrollLeft, this.nextBtn.disabled = this
      .getSlideVisibility(this.slides[this.slides.length - 1]))
  }
}
customElements.define("carousel-slider", CarouselSlider),
  /*!
   * OverlayScrollbars
   * Version: 2.5.0
   
   * Released under the MIT license.
   */
  window.OverlayScrollbarsGlobal = function(e) {
    let t = (e, t) => {
        let {
          o: i,
          u: s,
          _: n
        } = e, r, l = i, a = (e, t) => {
          let i = l,
            a = e,
            o = t || (s ? !s(i, a) : i !== a);
          return (o || n) && (l = a, r = i), [l, o, r]
        };
        return [t ? e => a(t(l, r), e) : a, e => [l, !!e, r]]
      },
      i = "undefined" != typeof window,
      s = i ? window : {},
      n = Math.max,
      r = Math.min,
      l = Math.round,
      a = Math.abs,
      o = s.cancelAnimationFrame,
      d = s.requestAnimationFrame,
      h = s.setTimeout,
      c = s.clearTimeout,
      u = e => void 0 !== s[e] ? s[e] : void 0,
      p = u("MutationObserver"),
      v = u("IntersectionObserver"),
      m = u("ResizeObserver"),
      g = u("ScrollTimeline"),
      y = i && Node.ELEMENT_NODE,
      {
        toString: f,
        hasOwnProperty: b
      } = Object.prototype,
      $ = /^\[object (.+)\]$/,
      L = e => void 0 === e,
      E = e => null === e,
      k = e => "number" == typeof e,
      S = e => "string" == typeof e,
      w = e => "boolean" == typeof e,
      H = e => "function" == typeof e,
      M = e => Array.isArray(e),
      _ = e => "object" == typeof e && !M(e) && !E(e),
      x = e => {
        let t = !!e && e.length,
          i = k(t) && t > -1 && t % 1 == 0;
        return !(!(M(e) || !H(e) && i) || t > 0 && _(e) && !(t - 1 in e))
      },
      C = e => {
        var t;
        if (!e || !_(e) || "object" !== (L(t = e) || E(t) ? `${t}` : f.call(t).replace($, "$1")
            .toLowerCase())) return !1;
        let i, s = "constructor",
          n = e[s],
          r = n && n.prototype,
          l = b.call(e, s),
          a = r && b.call(r, "isPrototypeOf");
        if (n && !l && !a) return !1;
        for (i in e);
        return L(i) || b.call(e, i)
      },
      T = e => {
        let t = HTMLElement;
        return !!e && (t ? e instanceof t : e.nodeType === y)
      },
      O = e => {
        let t = Element;
        return !!e && (t ? e instanceof t : e.nodeType === y)
      },
      q = () => performance.now(),
      D = (e, t, i, s, r) => {
        let l = 0,
          a = q(),
          h = n(0, i),
          c = i => {
            let o = q(),
              u = i ? 1 : 1 - (n(0, a + h - o) / h || 0),
              p = (t - e) * (H(r) ? r(u, u * h, 0, 1, h) : u) + e,
              v = o - a >= h || 1 === u;
            s && s(p, u, v), l = v ? 0 : d(() => c())
          };
        return c(), e => {
          o(l), e && c(e)
        }
      };

    function P(e, t) {
      if (x(e))
        for (let i = 0; i < e.length && !1 !== t(e[i], i, e); i++);
      else e && P(Object.keys(e), i => t(e[i], i, e));
      return e
    }
    let A = (e, t) => e.indexOf(t) >= 0,
      I = (e, t) => e.concat(t),
      B = (e, t, i) => (i || S(t) || !x(t) ? e.push(t) : Array.prototype.push.apply(e, t), e),
      N = e => Array.from(e || []),
      V = e => M(e) ? e : [e],
      j = e => !!e && !e.length,
      F = e => N(new Set(e)),
      W = (e, t, i) => {
        P(e, e => e && e.apply(void 0, t || [])), i || (e.length = 0)
      },
      z = "paddingTop",
      U = "paddingRight",
      R = "paddingLeft",
      G = "paddingBottom",
      Y = "marginLeft",
      X = "marginRight",
      Q = "marginBottom",
      Z = "overflowX",
      K = "overflowY",
      J = "width",
      ee = "height",
      et = "hidden",
      ei = "visible",
      es = (e, t, i, s) => {
        if (e && t) {
          let n = !0;
          return P(i, i => {
            (s ? s(e[i]) : e[i]) !== (s ? s(t[i]) : t[i]) && (n = !1)
          }), n
        }
        return !1
      },
      en = (e, t) => es(e, t, ["w", "h"]),
      er = (e, t) => es(e, t, ["x", "y"]),
      el = (e, t) => es(e, t, ["t", "r", "b", "l"]),
      ea = () => {},
      eo = (e, ...t) => e.bind(0, ...t),
      ed = e => {
        let t, i = e ? h : d,
          s = e ? c : o;
        return [n => {
          s(t), t = i(n, H(e) ? e() : e)
        }, () => s(t)]
      },
      eh = (e, t) => {
        let i, s, n, r = ea,
          {
            v: l,
            p: a,
            S: u
          } = t || {},
          p = function(t) {
            r(), c(i), i = s = void 0, r = ea, e.apply(this, t)
          },
          v = e => u && s ? u(s, e) : e,
          m = () => {
            r !== ea && p(v(n) || n)
          },
          g = function() {
            let e = N(arguments),
              t = H(l) ? l() : l;
            if (k(t) && t >= 0) {
              let u = H(a) ? a() : a,
                g = k(u) && u >= 0,
                y = t > 0 ? c : o,
                f = v(e) || e,
                b = p.bind(0, f);
              r();
              let $ = (t > 0 ? h : d)(b, t);
              r = () => y($), g && !i && (i = h(m, u)), s = n = f
            } else p(e)
          };
        return g.m = m, g
      },
      ec = (e, t) => Object.prototype.hasOwnProperty.call(e, t),
      eu = e => e ? Object.keys(e) : [],
      ep = (e, t, i, s, n, r, l) => ("object" == typeof e && !E(e) || H(e) || (e = {}), P([t, i, s,
        n, r, l
      ], t => {
        P(t, (i, s) => {
          let n = t[s];
          if (e === n) return !0;
          let r = M(n);
          if (n && C(n)) {
            let l = e[s],
              a = l;
            r && !M(l) ? a = [] : r || C(l) || (a = {}), e[s] = ep(a, n)
          } else e[s] = r ? n.slice() : n
        })
      }), e),
      ev = (e, t) => P(ep({}, e), (e, i, s) => {
        void 0 === e ? delete s[i] : t && e && C(e) && (s[i] = ev(e, t))
      }),
      em = e => {
        for (let t in e) return !1;
        return !0
      },
      eg = (e, t, i) => n(e, r(t, i)),
      ey = e => N(new Set((M(e) ? e : (e || "").split(" ")).filter(e => e))),
      ef = (e, t) => e && e.getAttribute(t),
      eb = (e, t, i) => {
        P(ey(t), t => {
          e && e.setAttribute(t, i || "")
        })
      },
      e$ = (e, t) => {
        P(ey(t), t => e && e.removeAttribute(t))
      },
      eL = (e, t) => {
        let i = ey(ef(e, t)),
          s = eo(eb, e, t),
          n = (e, t) => {
            let s = new Set(i);
            return P(ey(e), e => s[t](e)), N(s).join(" ")
          };
        return {
          O: e => s(n(e, "delete")),
          $: e => s(n(e, "add")),
          C(e) {
            let t = ey(e);
            return t.reduce((e, t) => e && i.includes(t), t.length > 0)
          }
        }
      },
      eE = (e, t, i) => {
        eL(e, t).O(i)
      },
      ek = (e, t, i) => (eL(e, t).$(i), eo(eE, e, t, i)),
      eS = (e, t, i, s) => {
        (s ? ek : eE)(e, t, i)
      },
      ew = e => eL(e, "class"),
      eH = (e, t) => {
        ew(e).O(t)
      },
      eM = (e, t) => (ew(e).$(t), eo(eH, e, t)),
      e_ = i && Element.prototype,
      ex = (e, t) => {
        let i = [],
          s = t ? O(t) && t : document;
        return s ? B(i, s.querySelectorAll(e)) : i
      },
      eC = (e, t) => !!O(e) && (e_.matches || e_.msMatchesSelector).call(e, t),
      eT = e => e ? N(e.childNodes) : [],
      e9 = e => e && e.parentElement,
      eO = (e, t) => O(e) && e.closest(t),
      eq = e => {
        if (x(e)) P(N(e), e => eq(e));
        else if (e) {
          let t = e9(e);
          t && t.removeChild(e)
        }
      },
      eD = (e, t, i) => {
        if (i && e) {
          let s, n = t;
          return x(i) ? (s = document.createDocumentFragment(), P(i, e => {
              e === n && (n = e.previousSibling), s.appendChild(e)
            })) : s = i, t && (n ? n !== t && (n = n.nextSibling) : n = e.firstChild), e
            .insertBefore(s, n || null), () => eq(i)
        }
        return ea
      },
      eP = (e, t) => eD(e, null, t),
      e8 = (e, t) => eD(e9(e), e && e.nextSibling, t),
      eA = e => {
        let t = document.createElement("div");
        return eb(t, "class", e), t
      },
      eI = e => {
        let t = eA();
        return t.innerHTML = e.trim(), P(eT(t), e => eq(e))
      },
      e1 = /^--/,
      eB = (e, t) => e.getPropertyValue(t) || e[t] || "",
      eN = e => {
        let t = e || 0;
        return isFinite(t) ? t : 0
      },
      eV = e => eN(parseFloat(e || "")),
      ej = e => `${(100*eN(e)).toFixed(3)}%`,
      eF = e => `${eN(e)}px`;

    function eW(e, t) {
      e && P(t, (t, i) => {
        try {
          let s = e.style,
            n = k(t) ? eF(t) : (t || "") + "";
          e1.test(i) ? s.setProperty(i, n) : s[i] = n
        } catch (r) {}
      })
    }

    function ez(e, t, i) {
      let n = S(t),
        r = n ? "" : {};
      if (e) {
        let l = s.getComputedStyle(e, i) || e.style;
        r = n ? eB(l, t) : t.reduce((e, t) => (e[t] = eB(l, t), e), r)
      }
      return r
    }
    let eU = e => "rtl" === ez(e, "direction"),
      eR = (e, t, i) => {
        let s = t ? `${t}-` : "",
          n = i ? `-${i}` : "",
          r = `${s}top${n}`,
          l = `${s}right${n}`,
          a = `${s}bottom${n}`,
          o = `${s}left${n}`,
          d = ez(e, [r, l, a, o]);
        return {
          t: eV(d[r]),
          r: eV(d[l]),
          b: eV(d[a]),
          l: eV(d[o])
        }
      },
      eG = (e, t) => `translate${_(e)?`(${e.x},${e.y})`:`${t?"X":"Y"}(${e})`}`,
      eY = {
        w: 0,
        h: 0
      },
      e0 = (e, t) => t ? {
        w: t[`${e}Width`],
        h: t[`${e}Height`]
      } : eY,
      eX = e => e0("inner", e || s),
      eQ = eo(e0, "offset"),
      eZ = eo(e0, "client"),
      eK = eo(e0, "scroll"),
      eJ = e => {
        let t = parseFloat(ez(e, J)) || 0,
          i = parseFloat(ez(e, ee)) || 0;
        return {
          w: t - l(t),
          h: i - l(i)
        }
      },
      e3 = e => e.getBoundingClientRect(),
      e7 = e => !(!e || !e[ee] && !e[J]),
      e4 = (e, t) => {
        let i = e7(e);
        return !e7(t) && i
      },
      e2 = (e, t, i, s) => {
        P(ey(t), t => {
          e.removeEventListener(t, i, s)
        })
      },
      e5 = (e, t, i, s) => {
        var n;
        let r = null == (n = s && s.H) || n,
          l = s && s.I || !1,
          a = s && s.A || !1,
          o = {
            passive: r,
            capture: l
          };
        return eo(W, ey(t).map(t => {
          let s = a ? n => {
            e2(e, t, s, l), i(n)
          } : i;
          return e.addEventListener(t, s, o), eo(e2, e, t, s, l)
        }))
      },
      e6 = e => e.stopPropagation(),
      te = e => e.preventDefault(),
      tt = {
        x: 0,
        y: 0
      },
      ti = e => {
        let t = e && e3(e);
        return t ? {
          x: t.left + s.scrollX,
          y: t.top + s.scrollY
        } : tt
      },
      ts = (e, t, i) => i ? i.n ? -e + 0 : i.i ? t - e : e : e,
      tn = (e, t) => [ts(0, e, t), ts(e, e, t)],
      tr = (e, t, i) => eg(0, 1, ts(e, t, i) / t || 0),
      tl = (e, t) => {
        let {
          x: i,
          y: s
        } = k(t) ? {
          x: t,
          y: t
        } : t || {};
        k(i) && (e.scrollLeft = i), k(s) && (e.scrollTop = s)
      },
      ta = e => ({
        x: e.scrollLeft,
        y: e.scrollTop
      }),
      to = (e, t) => {
        P(V(t), e)
      },
      td = e => {
        let t = new Map,
          i = (e, i) => {
            if (e) {
              let s = t.get(e);
              to(e => {
                s && s[e ? "delete" : "clear"](e)
              }, i)
            } else t.forEach(e => {
              e.clear()
            }), t.clear()
          },
          s = (e, n) => {
            if (S(e)) {
              let r = t.get(e) || new Set;
              return t.set(e, r), to(e => {
                H(e) && r.add(e)
              }, n), eo(i, e, n)
            }
            w(n) && n && i();
            let l = eu(e),
              a = [];
            return P(l, t => {
              let i = e[t];
              i && B(a, s(t, i))
            }), eo(W, a)
          };
        return s(e || {}), [s, i, (e, i) => {
          P(N(t.get(e)), e => {
            i && !j(i) ? e.apply(0, i) : e()
          })
        }]
      },
      th = e => JSON.stringify(e, (e, t) => {
        if (H(t)) throw 0;
        return t
      }),
      tc = (e, t) => e ? `${t}`.split(".").reduce((e, t) => e && ec(e, t) ? e[t] : void 0, e) :
      void 0,
      tu = {
        paddingAbsolute: !1,
        showNativeOverlaidScrollbars: !1,
        update: {
          elementEvents: [
            ["img", "load"]
          ],
          debounce: [0, 33],
          attributes: null,
          ignoreMutation: null
        },
        overflow: {
          x: "scroll",
          y: "scroll"
        },
        scrollbars: {
          theme: "os-theme-dark",
          visibility: "auto",
          autoHide: "never",
          autoHideDelay: 1300,
          autoHideSuspend: !1,
          dragScroll: !0,
          clickScroll: !1,
          pointers: ["mouse", "touch", "pen"]
        }
      },
      tp = (e, t) => {
        let i = {};
        return P(I(eu(t), eu(e)), s => {
          let n = e[s],
            r = t[s];
          if (_(n) && _(r)) ep(i[s] = {}, tp(n, r)), em(i[s]) && delete i[s];
          else if (ec(t, s) && r !== n) {
            let l = !0;
            if (M(n) || M(r)) try {
              th(n) === th(r) && (l = !1)
            } catch (a) {}
            l && (i[s] = r)
          }
        }), i
      },
      tv = (e, t, i) => s => [tc(e, s), i || void 0 !== tc(t, s)],
      tm = "data-overlayscrollbars",
      tg = "os-environment",
      ty = `${tg}-scrollbar-hidden`,
      tf = `${tm}-initialize`,
      tb = tm,
      t$ = `${tb}-overflow-x`,
      tL = `${tb}-overflow-y`,
      tE = "overflowVisible",
      tk = "updating",
      tS = `${tm}-viewport`,
      tw = "arrange",
      tH = "scrollbarHidden",
      tM = tE,
      t_ = `${tm}-padding`,
      tx = tM,
      tC = `${tm}-content`,
      tT = "os-size-observer",
      t9 = `${tT}-appear`,
      tO = `${tT}-listener`,
      tq = `${tO}-scroll`,
      tD = `${tO}-item`,
      tP = `${tD}-final`,
      t8 = "os-scrollbar",
      tA = `${t8}-rtl`,
      tI = `${t8}-horizontal`,
      t1 = `${t8}-vertical`,
      tB = `${t8}-track`,
      tN = `${t8}-handle`,
      tV = `${t8}-visible`,
      tj = `${t8}-cornerless`,
      tF = `${t8}-transitionless`,
      tW = `${t8}-interaction`,
      tz = `${t8}-unusable`,
      tU = `${t8}-auto-hide`,
      tR = `${tU}-hidden`,
      tG = `${t8}-wheel`,
      tY = `${tB}-interactive`,
      t0 = `${tN}-interactive`,
      tX = {},
      tQ = {},
      tZ = (e, t, i) => eu(e).map(s => {
        let {
          static: n,
          instance: r
        } = e[s], [l, a, o] = i || [], d = i ? r : n;
        if (d) {
          let h = i ? d(l, a, t) : d(t);
          return (o || tQ)[s] = h
        }
      }),
      tK = e => tQ[e],
      tJ = "__osSizeObserverPlugin",
      t3 = (e, t) => {
        let {
          T: i
        } = t, [s, n] = e("showNativeOverlaidScrollbars");
        return [s && i.x && i.y, n]
      },
      t7 = e => 0 === e.indexOf(ei),
      t4 = (e, t) => {
        let {
          D: i
        } = e, s = e => {
          let s = ez(i, e);
          return [s, "scroll" === (t ? t[e] : s)]
        }, [n, r] = s(Z), [l, a] = s(K);
        return {
          k: {
            x: n,
            y: l
          },
          R: {
            x: r,
            y: a
          }
        }
      },
      t2 = (e, t, i, s) => {
        let n = t.x || t.y,
          r = (e, t) => {
            let i = t7(e),
              s = t && i && e.replace(`${ei}-`, "") || (i && n ? "hidden" : "");
            return [t && !i ? e : "", t7(s) ? "hidden" : s]
          },
          [l, a] = r(i.x, t.x),
          [o, d] = r(i.y, t.y);
        return s[Z] = a && o ? a : l, s[K] = d && l ? d : o, t4(e, s)
      },
      t5 = "__osScrollbarsHidingPlugin",
      t6 = "__osClickScrollPlugin",
      ie, it = () => (ie || (ie = (() => {
        let e = (e, t, i, s) => {
            eP(e, t);
            let n = eZ(t),
              r = eQ(t),
              l = eJ(i);
            return s && eq(t), {
              x: r.h - n.h + l.h,
              y: r.w - n.w + l.w
            }
          },
          {
            body: i
          } = document,
          n = eI(`<div class="${tg}"><div></div></div>`)[0],
          r = n.firstChild,
          [l, , a] = td(),
          [o, d] = t({
            o: e(i, n, r),
            u: er
          }, eo(e, i, n, r, !0)),
          [h] = d(),
          c = (e => {
            let t = !1,
              i = eM(e, ty);
            try {
              t = "none" === ez(e, "scrollbar-width") || "none" === ez(e, "display",
                "::-webkit-scrollbar")
            } catch (s) {}
            return i(), t
          })(n),
          u = {
            x: 0 === h.x,
            y: 0 === h.y
          },
          p = {
            elements: {
              host: null,
              padding: !c,
              viewport: e => c && e === e.ownerDocument.body && e,
              content: !1
            },
            scrollbars: {
              slot: !0
            },
            cancel: {
              nativeScrollbarsOverlaid: !1,
              body: null
            }
          },
          v = ep({}, tu),
          m = eo(ep, {}, v),
          y = eo(ep, {}, p),
          f = {
            P: h,
            T: u,
            L: c,
            G: !!g,
            J: ((e, t) => {
              eW(e, {
                [Z]: et,
                [K]: et,
                direction: "rtl"
              }), tl(e, {
                x: 0
              });
              let i = ti(e),
                s = ti(t);
              tl(e, {
                x: -999
              });
              let n = ti(t);
              return {
                i: i.x === s.x,
                n: s.x !== n.x
              }
            })(n, r),
            K: eo(l, "r"),
            Z: y,
            tt: e => ep(p, e) && y(),
            nt: m,
            ot: e => ep(v, e) && m(),
            st: ep({}, p),
            et: ep({}, v)
          };
        return e$(n, "style"), eq(n), s.addEventListener("resize", () => {
          let e;
          if (!(c || u.x && u.y)) {
            let t = tK(t5);
            e = !!(t ? t.Y() : ea)(f, o)
          }
          a("r", [e])
        }), f
      })()), ie),
      ii = (e, t) => H(t) ? t.apply(0, e) : t,
      is = (e, t, i, s) => {
        let n = L(s) ? i : s;
        return ii(e, n) || t.apply(0, e)
      },
      ir = (e, t, i, s) => {
        let n = L(s) ? i : s,
          r = ii(e, n);
        return !!r && (T(r) ? r : t.apply(0, e))
      },
      il = new WeakMap,
      ia = e => il.get(e),
      io = (e, t, i, s) => {
        let n = !1,
          {
            ct: r,
            rt: l,
            lt: a,
            it: o,
            ut: d,
            ft: h
          } = s || {},
          c = eh(() => n && i(!0), {
            v: 33,
            p: 99
          }),
          [u, v] = ((e, t, i) => {
            let s = !1,
              n = !!i && new WeakMap,
              r = r => {
                if (n && i) {
                  let l = i.map(t => {
                    let [i, s] = t || [];
                    return [s && i ? (r || ex)(i, e) : [], s]
                  });
                  P(l, i => P(i[0], r => {
                    let l = i[1],
                      a = n.get(r) || [];
                    if (e.contains(r) && l) {
                      let o = e5(r, l, e => {
                        s ? (o(), n.delete(r)) : t(e)
                      });
                      n.set(r, B(a, o))
                    } else W(a), n.delete(r)
                  }))
                }
              };
            return r(), [() => {
              s = !0
            }, r]
          })(e, c, a),
          m = l || [],
          g = I(r || [], m),
          y = (n, r) => {
            if (!j(r)) {
              let l = d || ea,
                a = h || ea,
                c = [],
                u = [],
                p = !1,
                g = !1;
              if (P(r, i => {
                  let {
                    attributeName: n,
                    target: r,
                    type: d,
                    oldValue: h,
                    addedNodes: v,
                    removedNodes: y
                  } = i, f = "attributes" === d, b = e === r, $ = f && n, L = $ && ef(r, n ||
                    "") || null, E = $ && h !== L, k = A(m, n) && E;
                  if (t && ("childList" === d || !b)) {
                    let S = f && E,
                      w = S && o && eC(r, o),
                      H = (w ? !l(r, n, h, L) : !f || S) && !a(i, !!w, e, s);
                    P(v, e => B(c, e)), P(y, e => B(c, e)), g = g || H
                  }!t && b && E && !l(r, n, h, L) && (B(u, n), p = p || k)
                }), v(e => F(c).reduce((t, i) => (B(t, ex(e, i)), eC(i, e) ? B(t, i) : t), [])), t)
                return !n && g && i(!1), [!1];
              if (!j(u) || p) {
                let y = [F(u), p];
                return n || i.apply(0, y), y
              }
            }
          },
          f = new p(eo(y, !1));
        return [() => (f.observe(e, {
          attributes: !0,
          attributeOldValue: !0,
          attributeFilter: g,
          subtree: t,
          childList: t,
          characterData: t
        }), n = !0, () => {
          n && (u(), f.disconnect(), n = !1)
        }), () => {
          if (n) return c.m(), y(!0, f.takeRecords())
        }]
      },
      id = (e, i, s) => {
        let {
          _t: n,
          dt: r
        } = s || {}, l = tK(tJ), {
          J: a
        } = it(), o = eo(eU, e), [d] = t({
          o: !1,
          _: !0
        });
        return () => {
          let s = [],
            h = eI(`<div class="${tT}"><div class="${tO}"></div></div>`)[0],
            c = h.firstChild,
            u = e => {
              let t = e instanceof ResizeObserverEntry,
                s = !t && M(e),
                r = !1,
                l = !1,
                o = !0;
              if (t) {
                let [c, , u] = d(e.contentRect), p = e7(c), v = e4(c, u);
                o = !(r = !(l = !u || v) && !p)
              } else s ? [, o] = e : l = !0 === e;
              if (n && o) {
                let m = s ? e[0] : eU(h);
                tl(h, {
                  x: ts(3333333, 3333333, m && a),
                  y: 3333333
                })
              }
              r || i({
                vt: s ? e : void 0,
                ht: !s,
                dt: l
              })
            };
          if (m) {
            let p = new m(e => u(e.pop()));
            p.observe(c), B(s, () => {
              p.disconnect()
            })
          } else {
            if (!l) return ea;
            {
              let [v, g] = l(c, u, r);
              B(s, I([eM(h, t9), e5(h, "animationstart", v)], g))
            }
          }
          if (n) {
            let [y] = t({
              o: void 0
            }, o);
            B(s, e5(h, "scroll", e => {
              let t = y(),
                [i, s, n] = t;
              s && (eH(c, "ltr rtl"), eM(c, i ? "rtl" : "ltr"), u([!!i, s, n])), e6(e)
            }))
          }
          return eo(W, B(s, eP(e, h)))
        }
      },
      ih = (e, i) => {
        let s, n = eA("os-trinsic-observer"),
          [r] = t({
            o: !1
          }),
          l = (e, t) => {
            if (e) {
              var s;
              let n = r(0 === (s = e).h || s.isIntersecting || s.intersectionRatio > 0),
                [, l] = n;
              return l && !t && i(n) && [n]
            }
          },
          a = (e, t) => l(t.pop(), e);
        return [() => {
          let t = [];
          if (v)(s = new v(eo(a, !1), {
            root: e
          })).observe(n), B(t, () => {
            s.disconnect()
          });
          else {
            let i = () => {
              let e = eQ(n);
              l(e)
            };
            B(t, id(n, i)()), i()
          }
          return eo(W, B(t, eP(e, n)))
        }, () => s && a(!0, s.takeRecords())]
      },
      ic = (e, i, s, n) => {
        let r, l, a, o, d, h, {
            L: c
          } = it(),
          u = `[${tb}]`,
          p = `[${tS}]`,
          v = ["tabindex"],
          g = ["wrap", "cols", "rows"],
          y = ["id", "class", "style", "open"],
          {
            gt: f,
            bt: b,
            D: $,
            wt: L,
            St: E,
            V: w,
            yt: _,
            Ot: x
          } = e,
          C = {
            $t: !1,
            N: eU(f)
          },
          T = it(),
          q = tK(t5),
          [D] = t({
            u: en,
            o: {
              w: 0,
              h: 0
            }
          }, () => {
            let t = q && q.M(e, i, C, T, s).W,
              n = _(tM),
              r = !w && _(tw),
              l = r && ta($);
            x(tM), w && x(tk, !0);
            let a = r && t && t()[0],
              o = eK(L),
              d = eK($),
              h = eJ($);
            return x(tM, n), w && x(tk), a && a(), tl($, l), {
              w: d.w + o.w + h.w,
              h: d.h + o.h + h.h
            }
          }),
          B = E ? g : I(y, g),
          N = eh(n, {
            v: () => r,
            p: () => l,
            S(e, t) {
              let [i] = e, [s] = t;
              return [I(eu(i), eu(s)).reduce((e, t) => (e[t] = i[t] || s[t], e), {})]
            }
          }),
          V = e => {
            if (w) {
              let t = eU(f);
              ep(e, {
                Ct: h !== t
              }), ep(C, {
                N: t
              }), h = t
            }
          },
          j = e => {
            P(e || v, e => {
              if (A(v, e)) {
                let t = ef(b, e);
                S(t) ? eb($, e, t) : e$($, e)
              }
            })
          },
          F = (e, t) => {
            let [i, s] = e, r = {
              xt: s
            };
            return ep(C, {
              $t: i
            }), t || n(r), r
          },
          W = ({
            ht: e,
            vt: t,
            dt: i
          }) => {
            let [s, r] = t || [], l = {
              ht: e || i,
              dt: i,
              Ct: r
            };
            V(l), t && ep(C, {
              N: s
            }), ((!e || i || t) && c ? N : n)(l)
          },
          z = (e, t) => {
            let [, i] = D(), s = {
              Ht: i
            };
            return V(s), i && !t && (e ? n : N)(s), s
          },
          U = (e, t, i) => {
            let s = {
              It: t
            };
            return V(s), t && !i ? N(s) : w || j(e), s
          },
          {
            K: R
          } = T,
          [G, Y] = L ? ih(b, F) : [],
          X = !w && id(b, W, {
            dt: !0,
            _t: !0
          }),
          [Q, Z] = io(b, !1, U, {
            rt: y,
            ct: I(y, v)
          }),
          K = w && m && new m(e => {
            let t = e[e.length - 1].contentRect;
            W({
              ht: !0,
              dt: e4(t, d)
            }), d = t
          });
        return [() => {
          j(), K && K.observe(b);
          let e = X && X(),
            t = G && G(),
            i = Q(),
            s = R(e => {
              let [, t] = D();
              N({
                zt: e,
                Ht: t
              })
            });
          return () => {
            K && K.disconnect(), e && e(), t && t(), o && o(), i(), s()
          }
        }, ({
          Et: e,
          At: t,
          Tt: i
        }) => {
          let s = {},
            [n] = e("update.ignoreMutation"),
            [d, h] = e("update.attributes"),
            [c, v] = e("update.elementEvents"),
            [m, g] = e("update.debounce"),
            y = t || i;
          if (v || h) {
            a && a(), o && o();
            let [f, b] = io(L || $, !0, z, {
              ct: I(B, d || []),
              lt: c,
              it: u,
              ft(e, t) {
                var i;
                let {
                  target: s,
                  attributeName: r
                } = e;
                return !(t || !r || w) && ((e, t, i) => {
                  let s = eO(e, t),
                    n = e && ((e, t) => {
                      let i = t ? O(t) && t : document;
                      return i ? i.querySelector(e) : null
                    })(i, s),
                    r = eO(n, t) === s;
                  return !(!s || !n) && (s === e || n === e || r && eO(eO(e, i), t) !==
                    s)
                })(s, u, p) || !!eO(s, `.${t8}`) || (i = e, !!(H(n) && n(i)))
              }
            });
            o = f(), a = b
          }
          if (g) {
            if (N.m(), M(m)) {
              let E = m[0],
                S = m[1];
              r = k(E) && E, l = k(S) && S
            } else k(m) ? (r = m, l = !1) : (r = !1, l = !1)
          }
          if (y) {
            let _ = Z(),
              x = Y && Y(),
              C = a && a();
            _ && ep(s, U(_[0], _[1], y)), x && ep(s, F(x[0], y)), C && ep(s, z(C[0], y))
          }
          return V(s), s
        }, C]
      },
      iu = (e, t, i, s) => {
        let {
          Z: n,
          J: r
        } = it(), {
          scrollbars: l
        } = n(), {
          slot: a
        } = l, {
          gt: o,
          bt: d,
          D: c,
          Dt: u,
          kt: p,
          Rt: v,
          V: m
        } = t, {
          scrollbars: y
        } = u ? {} : e, {
          slot: f
        } = y || {}, b = new Map, $ = e => g && new g({
          source: p,
          axis: e
        }), L = $("x"), E = $("y"), k = ir([o, d, c], () => m && v ? o : d, a, f), S = (e, t) => {
          if (t) {
            let s = e ? J : ee,
              {
                Mt: n,
                Vt: r
              } = t,
              l = e3(r)[s],
              a = e3(n)[s];
            return eg(0, 1, l / a || 0)
          }
          let o = e ? "x" : "y",
            {
              Lt: d,
              Pt: h
            } = i,
            c = h[o],
            u = d[o];
          return eg(0, 1, c / (c + u) || 0)
        }, H = (e, t) => ep(e, t ? {
          clear: ["left"]
        } : {}), M = e => {
          b.forEach((t, i) => {
            (!e || A(V(e), i)) && (P(t || [], e => {
              e && e.cancel()
            }), b.delete(i))
          })
        }, _ = (e, t, i, s) => {
          let n = b.get(e) || [],
            r = n.find(e => e && e.timeline === t);
          r ? r.effect = new KeyframeEffect(e, i, {
            composite: s
          }) : b.set(e, I(n, [e.animate(i, {
            timeline: t,
            composite: s
          })]))
        }, x = (e, t, i) => {
          let s = i ? eM : eH;
          P(e, e => {
            s(e.Ut, t)
          })
        }, C = (e, t) => {
          P(e, e => {
            let [i, s] = t(e);
            eW(i, s)
          })
        }, T = (e, t) => {
          C(e, e => {
            let {
              Vt: i
            } = e;
            return [i, {
              [t ? J : ee]: ej(S(t))
            }]
          })
        }, O = (e, t) => {
          let {
            Lt: s
          } = i, n = t ? s.x : s.y, l = (e, i, s) => eG(ej(((e, t, i, s) => {
            let n = S(i, e);
            return 1 / n * (1 - n) * (s ? 1 - t : t) || 0
          })(e, tr(i, n, s), t, s)), t);
          if (L && E) P(e, e => {
            let {
              Ut: i,
              Vt: s
            } = e, a = t && eU(i) && r;
            _(s, t ? L : E, H({
              transform: tn(n, a).map(t => l(e, t, a))
            }, a))
          });
          else {
            let a = ta(p);
            C(e, e => {
              let {
                Vt: i,
                Ut: s
              } = e;
              return [i, {
                transform: l(e, t ? a.x : a.y, t && eU(s) && r)
              }]
            })
          }
        }, q = e => m && !v && e9(e) === c, D = [], N = [], F = [], z = (e, t, i) => {
          let s = w(i);
          (!s || i) && x(N, e, t), s && i || x(F, e, t)
        }, U = e => {
          let t = e ? N : F,
            i = j(t) ? tF : "",
            n = eA(`${t8} ${e?tI:t1} ${i}`),
            r = eA(tB),
            l = eA(tN),
            a = {
              Ut: n,
              Mt: r,
              Vt: l
            };
          return B(t, a), B(D, [eP(n, r), eP(r, l), eo(eq, n), M, s(a, z, O, e)]), a
        }, R = eo(U, !0), G = eo(U, !1);
        return R(), G(), [{
          Bt() {
            T(N, !0), T(F)
          },
          Nt() {
            O(N, !0), O(F)
          },
          jt() {
            if (m) {
              let {
                Lt: e
              } = i;
              if (L && E) P(I(F, N), ({
                Ut: t
              }) => {
                if (q(t)) {
                  let i = (e, i, s) => {
                    let n = s && eU(t) && r;
                    _(t, e, H({
                      transform: tn(i - .5, n).map(e => eG(eF(e), s))
                    }, n), "add")
                  };
                  i(L, e.x, !0), i(E, e.y)
                } else M(t)
              });
              else {
                let t = ta(p),
                  s = i => {
                    let {
                      Ut: s
                    } = i, n = q(s) && s, l = (e, t, i) => {
                      let s = t * tr(e, t, i);
                      return eF(i ? -s : s)
                    };
                    return [n, {
                      transform: n ? eG({
                        x: l(t.x, e.x, eU(s) && r),
                        y: l(t.y, e.y)
                      }) : ""
                    }]
                  };
                C(N, s), C(F, s)
              }
            }
          },
          Ft: z,
          qt: {
            G: L,
            Wt: N,
            Xt: R,
            Yt: eo(C, N)
          },
          Gt: {
            G: E,
            Wt: F,
            Xt: G,
            Yt: eo(C, F)
          }
        }, () => (eP(k, N[0].Ut), eP(k, F[0].Ut), h(() => {
          z(tF)
        }, 300), eo(W, D))]
      },
      ip = (e, t, i) => {
        let {
          bt: s,
          kt: n,
          Jt: r
        } = t;
        return (t, a, o, d) => {
          let {
            Ut: h,
            Mt: c,
            Vt: u
          } = t, [p, v] = ed(333), [m, g] = ed(), y = eo(o, [t], d), f = !!n.scrollBy, b =
            `client${d?"X":"Y"}`, $ = d ? J : ee, L = d ? "left" : "top", E = d ? "w" : "h", k =
            d ? "x" : "y", S = e => e.propertyName.indexOf($) > -1, w = !0;
          return eo(W, [e5(h, "pointerenter", () => {
            a(tW, !0)
          }), e5(h, "pointerleave pointercancel", () => {
            a(tW, !1)
          }), e5(h, "wheel", e => {
            let {
              deltaX: t,
              deltaY: i,
              deltaMode: r
            } = e;
            f && w && 0 === r && e9(h) === s && n.scrollBy({
              left: t,
              top: i,
              behavior: "smooth"
            }), w = !1, a(tG, !0), p(() => {
              w = !0, a(tG)
            }), te(e)
          }, {
            H: !1,
            I: !0
          }), e5(u, "transitionstart", e => {
            if (S(e)) {
              let t = () => {
                y(), m(t)
              };
              t()
            }
          }), e5(u, "transitionend transitioncancel", e => {
            S(e) && (g(), y())
          }), e5(h, "mousedown", eo(e5, r, "click", e6, {
            A: !0,
            I: !0
          }), {
            I: !0
          }), (() => {
            let t = "pointerup pointerleave pointercancel lostpointercapture",
              a = (e, t) => s => {
                let {
                  Lt: r
                } = i, l = eQ(c)[E] - eQ(u)[E], a = t * s / l * r[k];
                tl(n, {
                  [k]: e + a
                })
              };
            return e5(c, "pointerdown", i => {
              let o = eO(i.target, `.${tN}`) === u,
                d = o ? u : c,
                h = e.scrollbars,
                {
                  button: p,
                  isPrimary: v,
                  pointerType: m
                } = i,
                {
                  pointers: g
                } = h;
              if (0 === p && v && h[o ? "dragScroll" : "clickScroll"] && (g || [])
                .includes(m)) {
                let y = !o && i.shiftKey,
                  f = eo(e3, u),
                  S = eo(e3, c),
                  w = (e, t) => (e || f())[L] - (t || S())[L],
                  H = l(e3(n)[$]) / eQ(n)[E] || 1,
                  M = a(ta(n)[k] || 0, 1 / H),
                  _ = i[b],
                  x = f(),
                  C = S(),
                  T = x[$],
                  O = w(x, C) + T / 2,
                  q = _ - C[L],
                  D = o ? 0 : q - O,
                  P = e => {
                    W(A), d.releasePointerCapture(e.pointerId)
                  },
                  A = [ek(s, tb, "scrollbarPressed"), e5(r, t, P), e5(r,
                    "selectstart", e => te(e), {
                      H: !1
                    }), e5(c, t, P), e5(c, "pointermove", e => {
                    let t = e[b] - _;
                    (o || y) && M(D + t)
                  })];
                if (d.setPointerCapture(i.pointerId), y) M(D);
                else if (!o) {
                  let I = tK(t6);
                  I && B(A, I(M, w, D, T, q))
                }
              }
            })
          })(), v, g])
        }
      },
      iv = ({
        wt: e
      }) => ({
        Zt: t,
        un: i,
        Tt: s
      }) => {
        let {
          xt: n
        } = t || {}, {
          $t: r
        } = i;
        e && (n || s) && eW(e, {
          [ee]: r && "100%"
        })
      },
      im = ({
        bt: e,
        cn: i,
        D: s,
        V: n
      }, r) => {
        let [l, a] = t({
          u: el,
          o: eR()
        }, eo(eR, e, "padding", ""));
        return ({
          Et: e,
          Zt: t,
          un: o,
          Tt: d
        }) => {
          let [h, c] = a(d), {
            L: u
          } = it(), {
            ht: p,
            Ht: v,
            Ct: m
          } = t || {}, {
            N: g
          } = o, [y, f] = e("paddingAbsolute");
          (p || c || d || v) && ([h, c] = l(d));
          let b = !n && (f || m || c);
          if (b) {
            let $ = !y || !i && !u,
              L = h.r + h.l,
              E = h.t + h.b,
              k = {
                [X]: $ && !g ? -L : 0,
                [Q]: $ ? -E : 0,
                [Y]: $ && g ? -L : 0,
                top: $ ? -h.t : 0,
                right: $ ? g ? -h.r : "auto" : 0,
                left: $ ? g ? "auto" : -h.l : 0,
                [J]: $ && `calc(100% + ${L}px)`
              },
              S = {
                [z]: $ ? h.t : 0,
                [U]: $ ? h.r : 0,
                [G]: $ ? h.b : 0,
                [R]: $ ? h.l : 0
              };
            eW(i || s, k), eW(s, S), ep(r, {
              cn: h,
              fn: !$,
              j: i ? S : ep({}, k, S)
            })
          }
          return {
            _n: b
          }
        }
      },
      ig = (e, i) => {
        let r = it(),
          {
            bt: l,
            cn: a,
            D: o,
            V: d,
            Ot: h,
            Rt: c,
            ln: u
          } = e,
          {
            L: p,
            T: v
          } = r,
          m = c && d,
          g = eo(n, 0),
          y = {
            u: en,
            o: {
              w: 0,
              h: 0
            }
          },
          f = (e, t) => {
            let i = s.devicePixelRatio % 1 != 0 ? 1 : 0,
              n = {
                w: g(e.w - t.w),
                h: g(e.h - t.h)
              };
            return {
              w: n.w > i ? n.w : 0,
              h: n.h > i ? n.h : 0
            }
          },
          [b, $] = t(y, eo(eJ, o)),
          [L, E] = t(y, eo(eK, o)),
          [k, S] = t(y),
          [w, H] = t(y),
          [M] = t({
            u: er,
            o: {
              x: et,
              y: et
            }
          }),
          _ = tK(t5);
        return ({
          Et: t,
          Zt: s,
          un: c,
          Tt: y
        }, {
          _n: x
        }) => {
          let {
            ht: C,
            It: T,
            Ht: O,
            xt: q,
            Ct: D,
            zt: P
          } = s || {}, {
              $t: A
            } = c, I = _ && _.M(e, i, c, r, t), {
              q: B,
              W: N,
              X: V,
              F: j
            } = I || {}, F = (e, t) => {
              if (eW(o, {
                  [ee]: ""
                }), t) {
                let {
                  fn: s,
                  cn: n
                } = i, {
                  R: r
                } = e, a = eJ(l), d = eZ(l), h = "content-box" === ez(o, "boxSizing"), c = s ||
                  h ? n.b + n.t : 0, u = !(v.x && h);
                eW(o, {
                  [ee]: d.h + a.h + (r.x && u && j ? j(e).U.x : 0) - c
                })
              }
            }, [W, z] = t3(t, r), [U, R] = t("overflow"), G = !d && (C || O || T || z || q), Y =
            C || x || O || D || P || z, X = t7(U.x), Q = t7(U.y), J = X || Q, et, ei = $(y), es =
            E(y), en = S(y), er = H(y);
          if (z && p && h(tH, !W), G && (et = t4(e), F(et, A)), Y) {
            J && h(tM, !1);
            let [el, ea] = N ? N(et) : [], [eo, ed] = ei = b(y), [eh, ec] = es = L(y), eu = eZ(o),
              ev = eh, em = eu;
            el && el(), (ec || ed || z) && ea && !W && B && B(ea, eh, eo);
            let eg = eX(u),
              ey = {
                w: g(n(eh.w, ev.w) + eo.w),
                h: g(n(eh.h, ev.h) + eo.h)
              },
              ef = {
                w: g((m ? eg.w : em.w + g(eu.w - eh.w)) + eo.w),
                h: g((m ? eg.h : em.h + g(eu.h - eh.h)) + eo.h)
              };
            er = w(ef), en = k(f(ey, ef), y)
          }
          let [e$, eL] = er, [eE, ek] = en, [ew, eH] = es, [eM, e_] = ei, ex = {
            x: eE.w > 0,
            y: eE.h > 0
          }, eC = X && Q && (ex.x || ex.y) || X && ex.x && !ex.y || Q && ex.y && !ex.x;
          if (x || D || P || e_ || eH || eL || ek || R || z || G || Y) {
            let eT = {},
              e9 = t2(e, ex, U, eT);
            V && V(e9, c, !!B && B(e9, ew, eM), eT), G && F(e9, A), d ? (eb(l, t$, eT[Z]), eb(l,
              tL, eT[K])) : eW(o, eT)
          }
          eS(l, tb, tE, eC), eS(a, t_, tx, eC), d || eS(o, tS, tM, J);
          let [eO, eq] = M(t4(e).k);
          return ep(i, {
            k: eO,
            Pt: {
              x: e$.w,
              y: e$.h
            },
            Lt: {
              x: eE.w,
              y: eE.h
            },
            en: ex
          }), {
            sn: eq,
            tn: eL,
            nn: ek
          }
        }
      },
      iy = (e, t, i, s) => {
        let n = tv(t, {}),
          [r, l, a, o, d] = (e => {
            let [t, i, s] = (e => {
              let t = it(),
                {
                  Z: i,
                  L: s
                } = t,
                {
                  elements: n
                } = i(),
                {
                  host: r,
                  padding: l,
                  viewport: a,
                  content: o
                } = n,
                d = T(e),
                h = d ? {} : e,
                {
                  elements: c
                } = h,
                {
                  host: u,
                  padding: p,
                  viewport: v,
                  content: m
                } = c || {},
                g = d ? e : h.target,
                y = eC(g, "textarea"),
                f = g.ownerDocument,
                b = f.documentElement,
                $ = g === f.body,
                L = f.defaultView,
                E = () => f.activeElement,
                k = e => {
                  e && e.focus && e.focus()
                },
                S = eo(is, [g]),
                w = eo(ir, [g]),
                H = eo(ii, [g]),
                M = eo(eA, ""),
                _ = eo(S, M, a),
                x = eo(w, M, o),
                C = _(v),
                O = C === g,
                q = O && $,
                D = !O && x(m),
                P = !O && T(C) && C === D,
                I = P && !!H(o),
                N = I ? _() : C,
                V = I ? D : x(),
                j = q ? b : P ? N : C,
                F = y ? S(M, r, u) : g,
                z = {
                  gt: g,
                  bt: q ? j : F,
                  D: j,
                  cn: !O && w(M, l, p),
                  wt: P ? V : D,
                  kt: q ? b : j,
                  Kt: q ? f : j,
                  rn: $ ? b : g,
                  ln: L,
                  Jt: f,
                  St: y,
                  Rt: $,
                  Dt: d,
                  V: O,
                  an: P,
                  yt(e) {
                    var t, i, s;
                    return t = j, i = O ? tb : tS, s = e, eL(t, i).C(s)
                  },
                  Ot: (e, t) => eS(j, O ? tb : tS, e, t)
                },
                U = eu(z).reduce((e, t) => {
                  let i = z[t];
                  return B(e, !(!i || !T(i) || e9(i)) && i)
                }, []),
                R = e => e ? A(U, e) : null,
                {
                  gt: G,
                  bt: Y,
                  cn: X,
                  D: Q,
                  wt: Z
                } = z,
                K = [() => {
                  e$(Y, [tb, tf]), e$(G, tf), $ && e$(b, [tf, tb])
                }],
                J = y && R(Y),
                ee = y ? G : eT([Z, Q, X, Y, G].find(e => !1 === R(e))),
                et = q ? G : Z || Q,
                ei = eo(W, K);
              return [z, () => {
                let e = E(),
                  t = e => {
                    eP(e9(e), eT(e)), eq(e)
                  },
                  i = e => e ? e5(e, "focus blur", e => {
                    e6(e), e.stopImmediatePropagation()
                  }, {
                    I: !0,
                    H: !1
                  }) : ea,
                  n = i(e);
                if (eb(Y, tb, O ? "viewport" : "host"), eb(X, t_, ""), eb(Z, tC, ""), O || (
                    eb(Q, tS, ""), $ && ek(b, tb, "body")), J && (e8(G, Y), B(K, () => {
                    e8(Y, G), eq(Y)
                  })), eP(et, ee), eP(Y, X), eP(X || Y, !O && Q), eP(Q, Z), B(K, [n, () => {
                    let e = E(),
                      s = i(e);
                    e$(X, t_), e$(Z, tC), e$(Q, [t$, tL, tS]), R(Z) && t(Z), R(Q) && t(
                      Q), R(X) && t(X), k(e), s()
                  }]), s && !O && (ek(Q, tS, tH), B(K, eo(e$, Q, tS))), O || L.top !== L ||
                  e !== g) k(e);
                else {
                  let r = "tabindex",
                    l = ef(Q, r);
                  eb(Q, r, "-1"), k(Q);
                  let a = () => l ? eb(Q, r, l) : e$(Q, r),
                    o = e5(f, "pointerdown keydown", () => {
                      a(), o()
                    });
                  B(K, [a, o])
                }
                return n(), ee = 0, ei
              }, ei]
            })(e), n = {
              cn: {
                t: 0,
                r: 0,
                b: 0,
                l: 0
              },
              fn: !1,
              j: {
                [X]: 0,
                [Q]: 0,
                [Y]: 0,
                [z]: 0,
                [U]: 0,
                [G]: 0,
                [R]: 0
              },
              Pt: {
                x: 0,
                y: 0
              },
              Lt: {
                x: 0,
                y: 0
              },
              k: {
                x: et,
                y: et
              },
              en: {
                x: !1,
                y: !1
              }
            }, {
              gt: r,
              D: l,
              V: a
            } = t, {
              L: o,
              T: d
            } = it(), h = !o && (d.x || d.y), c = [iv(t), im(t, n), ig(t, n)];
            return [i, e => {
              let t = {},
                i = h && ta(l),
                s = a ? ek(l, tb, tk) : ea;
              return P(c, i => {
                ep(t, i(e, t) || {})
              }), s(), tl(l, i), a || tl(r, 0), t
            }, n, t, s]
          })(e),
          [h, c, u] = ic(o, a, n, e => {
            y({}, e)
          }),
          [p, v, , m] = ((e, t, i, s, n, r) => {
            let l, a, o, d, h, c = ea,
              u = 0,
              [p, v] = ed(),
              [m, g] = ed(),
              [y, f] = ed(100),
              [b, $] = ed(100),
              [L, E] = ed(100),
              [k, S] = ed(() => u),
              [w, H] = iu(e, n, s, ip(t, n, s)),
              {
                bt: M,
                Kt: _,
                Rt: x
              } = n,
              {
                Ft: C,
                Bt: T,
                Nt: O,
                jt: q
              } = w,
              D = e => {
                C(tU, e, !0), C(tU, e, !1)
              },
              P = (e, t) => {
                if (S(), e) C(tR);
                else {
                  let i = eo(C, tR, !0);
                  u > 0 && !t ? k(i) : i()
                }
              },
              A = e => "mouse" === e.pointerType,
              I = e => {
                A(e) && (d = a) && P(!0)
              },
              N = [f, S, $, E, g, v, () => c(), e5(M, "pointerover", I, {
                A: !0
              }), e5(M, "pointerenter", I), e5(M, "pointerleave", e => {
                A(e) && (d = !1, a && P(!1))
              }), e5(M, "pointermove", e => {
                A(e) && l && p(() => {
                  f(), P(!0), b(() => {
                    l && P(!1)
                  })
                })
              }), e5(_, "scroll", e => {
                m(() => {
                  O(), o && P(!0), y(() => {
                    o && !d && P(!1)
                  })
                }), r(e), q()
              })];
            return [() => eo(W, B(N, H())), ({
              Et: e,
              Tt: t,
              Zt: n,
              Qt: r
            }) => {
              let {
                tn: d,
                nn: p,
                sn: v
              } = r || {}, {
                  Ct: m,
                  dt: g
                } = n || {}, {
                  N: y
                } = i, {
                  T: f
                } = it(), {
                  Lt: b,
                  k: $,
                  en: E
                } = s, [k, S] = e("showNativeOverlaidScrollbars"), [w, H] = e(
                  "scrollbars.theme"), [M, A] = e("scrollbars.visibility"), [I, B] = e(
                  "scrollbars.autoHide"), [N, V] = e("scrollbars.autoHideSuspend"), [j] = e(
                  "scrollbars.autoHideDelay"), [F, W] = e("scrollbars.dragScroll"), [z, U] =
                e("scrollbars.clickScroll"), R = E.x || E.y, G = k && f.x && f.y, Y = (e,
                t) => {
                  let i = "visible" === M || "auto" === M && "scroll" === e;
                  return C(tV, i, t), i
                };
              if (u = j, g && !t && (N && R ? (D(!1), c(), L(() => {
                  c = e5(_, "scroll", eo(D, !0), {
                    A: !0
                  })
                })) : D(!0)), S && C("os-theme-none", G), H && (C(h), C(w, !0), h = w), V && !
                N && D(!0), B && (l = "move" === I, a = "leave" === I, P(!(o = "never" !== I),
                  !0)), W && C(t0, F), U && C(tY, z), v || A) {
                let X = Y($.x, !0),
                  Q = Y($.y, !1);
                C(tj, !(X && Q))
              }(d || p || m || t) && (T(), O(), q(), C(tz, !b.x, !0), C(tz, !b.y, !1), C(tA,
                y && !x))
            }, {}, w]
          })(e, t, u, a, o, s),
          g = e => eu(e).some(t => !!e[t]),
          y = (e, s) => {
            let {
              dn: n,
              Tt: r,
              At: a,
              vn: o
            } = e, d = n || {}, h = !!r, p = {
              Et: tv(t, d, h),
              dn: d,
              Tt: h
            };
            if (o) return v(p), !1;
            let m = s || c(ep({}, p, {
                At: a
              })),
              y = l(ep({}, p, {
                un: u,
                Zt: m
              }));
            v(ep({}, p, {
              Zt: m,
              Qt: y
            }));
            let f = g(m),
              b = g(y),
              $ = f || b || !em(d) || h;
            return $ && i(e, {
              Zt: m,
              Qt: y
            }), $
          };
        return [() => {
          let {
            rn: e,
            D: t
          } = o, i = ta(e), s = [h(), r(), p()];
          return tl(t, i), eo(W, s)
        }, y, () => ({
          hn: u,
          pn: a
        }), {
          gn: o,
          bn: m
        }, d]
      },
      ib = (e, t, i) => {
        let {
          nt: s
        } = it(), n = T(e), r = n ? e : e.target, l = ia(r);
        if (t && !l) {
          var a, o;
          let d = !1,
            h = [],
            c = {},
            u = e => {
              let t = ev(e, !0),
                i = tK("__osOptionsValidationPlugin");
              return i ? i(t, !0) : t
            },
            p = ep({}, s(), u(t)),
            [v, m, g] = td(),
            [y, f, b] = td(i),
            $ = (e, t) => {
              b(e, t), g(e, t)
            },
            [k, S, w, H, M] = iy(e, p, ({
              dn: e,
              Tt: t
            }, {
              Zt: i,
              Qt: s
            }) => {
              let {
                ht: n,
                Ct: r,
                xt: l,
                Ht: a,
                It: o,
                dt: d
              } = i, {
                tn: h,
                nn: c,
                sn: u
              } = s;
              $("updated", [x, {
                updateHints: {
                  sizeChanged: !!n,
                  directionChanged: !!r,
                  heightIntrinsicChanged: !!l,
                  overflowEdgeChanged: !!h,
                  overflowAmountChanged: !!c,
                  overflowStyleChanged: !!u,
                  contentMutation: !!a,
                  hostMutation: !!o,
                  appear: !!d
                },
                changedOptions: e || {},
                force: !!t
              }])
            }, e => $("scroll", [x, e])),
            _ = e => {
              var t;
              t = r, il.delete(t), W(h), d = !0, $("destroyed", [x, e]), m(), f()
            },
            x = {
              options(e, t) {
                if (e) {
                  let i = t ? s() : {},
                    n = tp(p, ep(i, u(e)));
                  em(n) || (ep(p, n), S({
                    dn: n
                  }))
                }
                return ep({}, p)
              },
              on: y,
              off(e, t) {
                e && t && f(e, t)
              },
              state() {
                let {
                  hn: e,
                  pn: t
                } = w(), {
                  N: i
                } = e, {
                  Pt: s,
                  Lt: n,
                  k: r,
                  en: l,
                  cn: a,
                  fn: o
                } = t;
                return ep({}, {
                  overflowEdge: s,
                  overflowAmount: n,
                  overflowStyle: r,
                  hasOverflow: l,
                  padding: a,
                  paddingAbsolute: o,
                  directionRTL: i,
                  destroyed: d
                })
              },
              elements() {
                let {
                  gt: e,
                  bt: t,
                  cn: i,
                  D: s,
                  wt: n,
                  kt: r,
                  Kt: l
                } = H.gn, {
                  qt: a,
                  Gt: o
                } = H.bn, d = e => {
                  let {
                    Vt: t,
                    Mt: i,
                    Ut: s
                  } = e;
                  return {
                    scrollbar: s,
                    track: i,
                    handle: t
                  }
                }, h = e => {
                  let {
                    Wt: t,
                    Xt: i
                  } = e, s = d(t[0]);
                  return ep({}, s, {
                    clone() {
                      let e = d(i());
                      return S({
                        vn: !0
                      }), e
                    }
                  })
                };
                return ep({}, {
                  target: e,
                  host: t,
                  padding: i || s,
                  viewport: s,
                  content: n || s,
                  scrollOffsetElement: r,
                  scrollEventElement: l,
                  scrollbarHorizontal: h(a),
                  scrollbarVertical: h(o)
                })
              },
              update: e => S({
                Tt: e,
                At: !0
              }),
              destroy: eo(_, !1),
              plugin: e => c[eu(e)[0]]
            };
          return B(h, [M]), a = r, o = x, il.set(a, o), tZ(tX, ib, [x, v, c]), ((e, t) => {
            let {
              nativeScrollbarsOverlaid: i,
              body: s
            } = t || {}, {
                T: n,
                L: r,
                Z: l
              } = it(), {
                nativeScrollbarsOverlaid: a,
                body: o
              } = l().cancel, d = L(s) ? o : s, h = (n.x || n.y) && (null != i ? i : a), c =
              e && (E(d) ? !r : d);
            return !!h || !!c
          })(H.gn.Rt, !n && e.cancel) ? (_(!0), x) : (B(h, k()), $("initialized", [x]), x.update(!
            0), x)
        }
        return l
      };
    return ib.plugin = e => {
      var t;
      let i = M(e),
        s = i ? e : [e],
        n = s.map(e => tZ(e, ib)[0]);
      return t = s, P(t, e => P(e, (t, i) => {
        tX[i] = e[i]
      })), i ? n : n[0]
    }, ib.valid = e => {
      let t = e && e.elements,
        i = H(t) && t();
      return C(i) && !!ia(i.target)
    }, ib.env = () => {
      let {
        P: e,
        T: t,
        L: i,
        J: s,
        G: n,
        st: r,
        et: l,
        Z: a,
        tt: o,
        nt: d,
        ot: h
      } = it();
      return ep({}, {
        scrollbarsSize: e,
        scrollbarsOverlaid: t,
        scrollbarsHiding: i,
        rtlScrollBehavior: s,
        scrollTimeline: n,
        staticDefaultInitialization: r,
        staticDefaultOptions: l,
        getDefaultInitialization: a,
        setDefaultInitialization: o,
        getDefaultOptions: d,
        setDefaultOptions: h
      })
    }, e.ClickScrollPlugin = {
      [t6]: {
        static: () => (e, t, i, s, n) => {
          let r = 0,
            l = ea,
            a = o => {
              l = D(o, o + s * Math.sign(i), 133, (i, o, d) => {
                e(i);
                let c = t();
                if (d && !(n >= c && n <= c + s)) {
                  if (r) a(i);
                  else {
                    let u = h(() => {
                      a(i)
                    }, 222);
                    l = () => {
                      clearTimeout(u)
                    }
                  }
                  r++
                }
              })
            };
          return a(0), () => l()
        }
      }
    }, e.OverlayScrollbars = ib, e.ScrollbarsHidingPlugin = {
      [t5]: {
        static: () => ({
          M(e, t, i, s, n) {
            let {
              V: r,
              D: l
            } = e, {
              L: a,
              T: o,
              P: d
            } = s, h = !r && !a && (o.x || o.y), [c] = t3(n, s), u = e => {
              let {
                R: t
              } = e, i = a || c ? 0 : 42, s = (e, t, s) => [t && !a ? e ? i : s : 0, e && !!
                i
              ], [n, r] = s(o.x, t.x, d.x), [l, h] = s(o.y, t.y, d.y);
              return {
                U: {
                  x: n,
                  y: l
                },
                B: {
                  x: r,
                  y: h
                }
              }
            }, p = (e, {
              N: i
            }, s, n) => {
              if (ep(n, {
                  [X]: 0,
                  [Q]: 0,
                  [Y]: 0
                }), !r) {
                let {
                  U: l,
                  B: a
                } = u(e), {
                  x: o,
                  y: d
                } = a, {
                  x: h,
                  y: c
                } = l, {
                  j: p
                } = t, v = i ? Y : X, m = i ? R : U, g = p[v], y = p[Q], f = p[m], b = p[
                  G];
                n[J] = `calc(100% + ${c+-1*g}px)`, n[v] = -c + g, n[Q] = -h + y, s && (n[
                  m] = f + (d ? c : 0), n[G] = b + (o ? h : 0))
              }
            };
            return {
              F: u,
              q(e, s, n) {
                if (h) {
                  let {
                    j: r
                  } = t, {
                    U: a,
                    B: o
                  } = u(e), {
                      x: d,
                      y: c
                    } = o, {
                      x: p,
                      y: v
                    } = a, {
                      N: m
                    } = i, g = r[m ? U : R], y = r.paddingTop, f = s.w + n.w, b = s.h + n.h,
                    $ = {
                      w: v && c ? `${v+f-g}px` : "",
                      h: p && d ? `${p+b-y}px` : ""
                    };
                  eW(l, {
                    "--os-vaw": $.w,
                    "--os-vah": $.h
                  })
                }
                return h
              },
              W(s) {
                if (h) {
                  let n = s || t4(e),
                    {
                      j: r
                    } = t,
                    {
                      B: a
                    } = u(n),
                    {
                      x: o,
                      y: d
                    } = a,
                    c = {},
                    v = e => P(e, e => {
                      c[e] = r[e]
                    });
                  o && v([Q, z, G]), d && v([Y, X, R, U]);
                  let m = ez(l, eu(c));
                  return eE(l, tS, tw), eW(l, c), [() => {
                    p(n, i, h, m), eW(l, m), ek(l, tS, tw)
                  }, n]
                }
                return [ea]
              },
              X: p
            }
          },
          Y() {
            let e = {
                w: 0,
                h: 0
              },
              t = 0,
              i = () => {
                let e = s.screen,
                  t = e.deviceXDPI || 0,
                  i = e.logicalXDPI || 1;
                return s.devicePixelRatio || t / i
              };
            return (s, n) => {
              let r = eX(),
                o = {
                  w: r.w - e.w,
                  h: r.h - e.h
                };
              if (0 === o.w && 0 === o.h) return;
              let d = a(o.w),
                h = a(o.h),
                c = {
                  w: a(l(r.w / (e.w / 100))),
                  h: a(l(r.h / (e.h / 100)))
                },
                u = i(),
                p = !((e, t) => {
                  let i = a(e),
                    s = a(t);
                  return !(i === s || i + 1 === s || i - 1 === s)
                })(c.w, c.h),
                v, m;
              return d > 2 && h > 2 && p && u !== t && u > 0 && ([m, v] = n(), ep(s.P, m)),
                e = r, t = u, v
            }
          }
        })
      }
    }, e.SizeObserverPlugin = {
      [tJ]: {
        static: () => (e, t, i) => {
          let s = "scroll",
            n = eI(
              `<div class="${tD}" dir="ltr"><div class="${tD}"><div class="${tP}"></div></div><div class="${tD}"><div class="${tP}" style="width: 200%; height: 200%"></div></div></div>`
              ),
            r = n[0],
            l = r.lastChild,
            a = r.firstChild,
            h = null == a ? void 0 : a.firstChild,
            c, u = eQ(r),
            p = u,
            v = !1,
            m = () => {
              tl(a, 3333333), tl(l, 3333333)
            },
            g = e => {
              c = 0, v && (u = p, t(!0 === e))
            },
            y = e => {
              p = eQ(r), v = !e || !en(p, u), e ? (e6(e), v && !c && (o(c), c = d(g))) : g(!
                1 === e), m()
            },
            f = [eP(e, n), e5(a, s, y), e5(l, s, y)];
          return eM(e, tq), eW(h, {
            [J]: 3333333,
            [ee]: 3333333
          }), d(m), [i ? eo(y, !1) : m, f]
        }
      }
    }, Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), e
  }({});
class ProductRecommendations extends HTMLElement {
  constructor() {
    super(), window.initLazyScript(this, this.init.bind(this), 500)
  }
  async init() {
    let {
      productId: e
    } = this.dataset;
    if (e) try {
      let t = await fetch(`${this.dataset.url}&product_id=${e}`);
      if (!t.ok) throw Error(t.status);
      let i = document.createElement("template");
      i.innerHTML = await t.text();
      let s = i.content.querySelector("product-recommendations");
      s && s.hasChildNodes() && (this.innerHTML = s.innerHTML), window.initLazyImages()
    } catch (n) {
      console.log(n)
    }
  }
}
if (customElements.define("product-recommendations", ProductRecommendations), setTimeout(() => {
    requestAnimationFrame(initLazyImages)
  }, 0), window.initLazyScript = initLazyScript, document.addEventListener("keydown", e => {
    "Tab" === e.code && document.body.classList.add("tab-used")
  }), document.addEventListener("DOMContentLoaded", () => {
    setTimeout(() => {
      document.body.classList.add("dom-loaded")
    }, 0), setTimeout(() => {
      document.body.classList.add("dom-loaded-plus-6")
    }, 6e3), theme.settings.externalLinksNewTab && document.addEventListener("click", e => {
      let t = "A" === e.target.tagName ? e.target : e.target.closest("a");
      t && "A" === t.tagName && window.location.hostname !== new URL(t.href).hostname && (t
        .target = "_blank")
    }), document.addEventListener("click", e => {
      "A" === e.target.tagName && window.location.hostname === new URL(e.target.href)
        .hostname && e.target.href.includes("#") && (document.getElementsByTagName("html")[0]
          .style.scrollBehavior = "smooth", setTimeout(() => {
            document.getElementsByTagName("html")[0].style.scrollBehavior = ""
          }, 1e3))
    })
  }), window.addEventListener("pageshow", e => {
    e.persisted ? document.dispatchEvent(new CustomEvent("on:bfcache:load-restore")) : document
      .dispatchEvent(new CustomEvent("on:bfcache:load-normal"))
  }), window.OverlayScrollbarsGlobal) {
  let t = () => {
    document.querySelectorAll(".slider--mobile").forEach(e => {
      window.OverlayScrollbarsGlobal.OverlayScrollbars({
        target: e.parentElement,
        elements: {
          viewport: e
        }
      }, {})
    })
  };
  t(), document.addEventListener("shopify:section:load", t)
}

document.addEventListener('click', function(e) {
  const card = e.target.closest('product-card[data-card-link]');
  if (!card) return;

  // Ignore clicks on real interactive elements
  if (
    e.target.closest('a, button, input, label, select, textarea') ||
    e.target.closest('.card__quick-add') ||
    e.target.closest('.card__swatches') ||
    e.target.closest('.card__compare')
  ) {
    return;
  }

  const url = card.getAttribute('data-card-link');
  if (url) {
    window.location.href = url;
  }
});
